import { CdkStepper, StepperSelectionEvent } from '@angular/cdk/stepper';
import { HttpContext, HttpParams } from '@angular/common/http';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  ValidatorFn,
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { createMask } from '@ngneat/input-mask';
import {
  Address2ComponentValue,
  AggregatorSearchComponentValue,
  applicantOf,
  Application,
  ApplicationApplicant,
  AssetCategoryTypeSelectionValue,
  AssetConditionValue,
  AssetFinanceProductType,
  AssetSelectionComponentValue,
  AzureStorageDocument,
  IndividualIdDocument,
  UploadedDocumentRef,
  BalloonPaymentValueOptions as BalloonPaymentOptions,
  BalloonPaymentValue,
  BrokerageSelectionValueOptions as BrokerageOptions,
  BrokerageSelectionValue,
  BrowserInfo,
  BusinessLoanTermValueOptions as BusinessLoanTermsOptions,
  BusinessNumberSearchResult,
  BusinessNumberSearchValue,
  BusinessSearchValue,
  SearchCompanyByABNResult,
  CommercialLoanTermsValueOptions as CommercialLoanTermsOptions,
  ConsumerLoanTermValueOptions as ConsumerLoanTermsOptions,
  ContactValue,
  SummaryContactValue,
  SummaryEntityValue,
  defaultDocuments,
  DigitalIdAuthenticationPayload,
  DigitalIdComponentEvent,
  DirectorValue, DirectorValueWithoutPropertyOwnerAddress,
  DirectorValueWithPropertyOwnerAddress,
  DocumentTag,
  DocumentWorklistCategory,
  DocumentWorklists,
  EmployerValue,
  EntityGuarantor,
  EntityMember,
  EntityPartner,
  EntityTrustee,
  EntityType,
  EntityTypeValueOptions as EntityTypeOptions,
  EntityTypes,
  EntityTypeValue,
  FacilityEstablishmentType,
  FacilityEstablishmentValue,
  FinanceTypeValueOptions as FinanceTypeOptions,
  FinanceTypeValue,
  GenderValue,
  getAssetCategory,
  getAssetCategoryType,
  GuarantorKybSelectionsEvent,
  GuarantorValue,
  KybKeyPeopleValue,
  IdentificationComponentValue,
  Individual,
  IndividualGuarantor,
  IndividualMember,
  IndividualPartner,
  IndividualTrustee,
  isInternalUserOrBroker,
  isJson,
  LoanTermValueOptions as LoanTermsOptions,
  LoanTermType,
  LoanTermValue,
  LtvSelectionType,
  MaterialShades,
  MemberValue,
  NotNullable,
  OnCompleteMessage,
  OnCompleteMessageError,
  PaginationInfo,
  ParsedDigitalIdResponse,
  parseJSON, parseRawAddress,
  PartnerValue,
  PaymentFrequencyValueOptions as PaymentFrequencyOptions,
  PaymentFrequencyValue,
  PortalLoginUser,
  PortalTheme,
  primaryEntityOf,
  PrimaryIndustrySelectionValue,
  PrivateSaleType,
  PropertyOwnerWithAddressValue,
  RepaymentTypeOptions,
  SalesforceContactSameAccountSelectionValue,
  SaveApplicationData,
  SecurityTypeSelectionType,
  SoleTraderValue,
  SortTypes,
  spouseOf,
  stringifyJSON,
  SubdivisionIndustrySelectionValue,
  TimeInAddressValue,
  TitleSelectionValueOptions as TitleOptions,
  TitleSelectionValue,
  TitleSelectionValueOptions,
  toUser,
  TransactionValue,
  TransactionValueOptions,
  TrusteeValue,
  UploadFileValue,
  UserSelectionValue,
  WhitelabelEntityDetails,
  WhitelabelStyles,
  yesNoToBoolean,
  calculateContinuityAges,
  computeAges,
  EquifaxDirectorScoreThresholdValue,
  thresholdMeets,
  isKybSourcedParty,
  ApplicationConfirmationDialogIndividual,
  GetApplicationindividualsPayload,
  savedIndividualsToConfirmationIndividuals,
  apiIndividualsToConfirmationIndividuals,
  ApplicationAddressApi,
  ApplicationCommercialEntityWrite,
  ApplicationIndividualRoleFlags,
  ApplicationIndividualWrite,
  ApplicationIndividual,
  individualRoleType,
  individualSignerRole,
  individualEntityRoleWrites,
  commercialEntityRoleType,
  Address,
  pairIndividualsByIdentity,
} from '@portal-workspace/grow-shared-library';
import cryptojs from 'crypto-js';
import sha256 from 'crypto-js/sha256';
import _ from 'lodash';
import moment, { Moment } from 'moment';
import { catchError, map, Observable, of, Subject, takeUntil } from 'rxjs';
import tinycolor2 from 'tinycolor2';
import { v4 } from 'uuid';

import { ChangeDetectorRef, inject, ViewRef } from '@angular/core';
import { createAsyncStore } from "@ngneat/loadoff";
import {
  AuthorisedSignatoryRoleOptions as authorisedSignatoryRoleOptions,
  AuthorisedSignatoryValue,
  countryOfCitizenshipByName,
  CoverTypeSelectionValueOptions as CoverTypeOptions,
  EmploymentStatusSelectionValueOptions as EmploymentStatusOptions,
  EmploymentStatusSelectionValue,
  IncomePeriodOptions as incomePeriodOptions,
  IncomeSelectionValue,
  LoanPurposeValue,
  MaritialStatusSelectionValueOptions as MaritialStatusOptions,
  MaritialStatusSelectionValue,
  Policy,
  PolicyValue,
  ReferenceValue,
  SecondaryIndustrySelectionValue,
  isRelativeRate,
} from '@portal-workspace/grow-shared-library';
import { fieldErrorMessages } from '../field-error-messages';
import { ApplicationDialogService } from './application-dialog-component/application-dialog.service';



declare var require: any;
import { Parser } from '@tmjeee/australia-address-parser';
import hexRgb from 'hex-rgb';

export const TOKEN_GROW_USER = 'growUser';
export const TOKEN_GROW_ACCESS_TOKEN = 'growAccessToken';
export const TOKEN_GROW_WHITELABEL = 'growWhiteLabel';
export const TOKEN_GROW_PORTAL_THEME = 'growPortalTheme';
export const TOKEN_GROW_REFRESH_TOKEN = 'growRefreshToken';
export const TOKEN_GROW_IS_2FA_ENTERED_WHEN_LOGIN = 'growIs2faEnteredWhenLogin';
export const TOKEN_LAST_VISITED_URL = 'growLastVisitedUrl';
export const TOKEN_LAST_VISITED_EMAIL = 'growLastVisitedEmail';

const parser = new Parser();
let encryptionKey = '';

export const setupComponentUtils = (options: {
  encryptionKey: string
}) => {
  encryptionKey = options.encryptionKey;
}

// ====================================================
// === localStroage encryption / decription
// ====================================================
export const getFromLocalStorage = (key: string, opts: {
  returnNullIfNotJson: boolean
} = {
  returnNullIfNotJson: false,
}): string | null => {
  const val = localStorage.getItem(key);
  if (val != null) {
    try {
      const decryptedVal = cryptojs.AES.decrypt(val, encryptionKey).toString(cryptojs.enc.Utf8);
      return decryptedVal;
    } catch(err) {
      if (opts.returnNullIfNotJson) {
        clearAllStorage();
        if (isJson(val)) {
          console.log(`Error decrypting returning as JSON `, val);
          return val;
        } else {
          console.log(`Error decrypting return null`, val);
          return null;
        }
      }
    }
  }
  return val;
}

export const setIntoLocalStorage = (key: string, value: string) => {
  const encryptedValue = cryptojs.AES.encrypt(value, encryptionKey).toString();
  localStorage.setItem(key, encryptedValue);
}



// ====================================================
// === handle ClientError from API
// ====================================================
// NOTE: handled in global-error-handler, use this to override at service level


// =====================================================
// === Download file and open in new window
// =====================================================
export const openWindowAndDownload = (blob: Blob) => {
  const url = window.URL.createObjectURL(blob);
  window.open(url, '_blank')?.focus();
  window.URL.revokeObjectURL(url);
}

export const openWindowAndDownloadWithFilename = (filename: string, blob: Blob) => {
  const url = window.URL.createObjectURL(blob);
  const downloadLink = window.document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = filename;
  downloadLink.target = '_blank';
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  window.URL.revokeObjectURL(url);
}

export const openWindowWithLink = (link: string) => {
  window.open(link, '_blank');
}



// =====================================================
// === Browser Detection
// =====================================================

export const setBrowseHeightAsCssVariable = () => {
  const windowHeight = window.innerHeight;
  const doc = document.documentElement;
  doc.style.setProperty('--portal-window-height', `${windowHeight}px`);
}

export const browserInfo = (): BrowserInfo => {
  let nVer = navigator.appVersion;
  let nAgt = navigator.userAgent;
  let browserName  = navigator.appName;
  let fullVersion  = ''+parseFloat(navigator.appVersion);
  let majorVersion = parseInt(navigator.appVersion,10);
  let nameOffset,verOffset,ix;

  // In Opera, the true version is after "Opera" or after "Version"
  if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
    browserName = "Opera";
    fullVersion = nAgt.substring(verOffset+6);
    if ((verOffset=nAgt.indexOf("Version"))!=-1)
      fullVersion = nAgt.substring(verOffset+8);
  }
  // In MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
    browserName = "Microsoft Internet Explorer";
    fullVersion = nAgt.substring(verOffset+5);
  }
  // In Chrome, the true version is after "Chrome"
  else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
    browserName = "Chrome";
    fullVersion = nAgt.substring(verOffset+7);
  }
  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
    browserName = "Safari";
    fullVersion = nAgt.substring(verOffset+7);
    if ((verOffset=nAgt.indexOf("Version"))!=-1)
      fullVersion = nAgt.substring(verOffset+8);
  }
  // In Firefox, the true version is after "Firefox"
  else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
    browserName = "Firefox";
    fullVersion = nAgt.substring(verOffset+8);
  }
  // In most other browsers, "name/version" is at the end of userAgent
  else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) <
    (verOffset=nAgt.lastIndexOf('/')) )
  {
    browserName = nAgt.substring(nameOffset,verOffset);
    fullVersion = nAgt.substring(verOffset+1);
    if (browserName.toLowerCase()==browserName.toUpperCase()) {
      browserName = navigator.appName;
    }
  }
  // trim the fullVersion string at semicolon/space if present
  if ((ix=fullVersion.indexOf(";"))!=-1)
    fullVersion=fullVersion.substring(0,ix);
  if ((ix=fullVersion.indexOf(" "))!=-1)
    fullVersion=fullVersion.substring(0,ix);

  majorVersion = parseInt(''+fullVersion,10);
  if (isNaN(majorVersion)) {
    fullVersion  = ''+parseFloat(navigator.appVersion);
    majorVersion = parseInt(navigator.appVersion,10);
  }

  return {
    browserName,
    fullVersion,
    majorVersion: String(majorVersion),
    appName: navigator.appName,
    userAgent: navigator.userAgent,
  }
}


// ====================================================
// ======= FormControl Validations / Validators
// ====================================================

// Asset Finance rate card age bucket: a rate, or "+N" for the previous bucket's rate plus N (max 2 decimals).
// Emptiness is left to Validators.required.
export const rateOrRelativeRateValidator: ValidatorFn = (control: AbstractControl) => {
  const v = `${control.value ?? ''}`.trim();
  return (v === '' || /^\+?\d+(\.\d{1,2})?$/.test(v)) ? null : {rateOrRelativeRate: true};
}

export const toRateCardCell = (formValue: string | null | undefined): string => `${formValue ?? '0'}`.trim();

export const fromRateCardCell = (rate: string | null | undefined): string | null => {
  const n = Number(rate);
  if (rate == null || `${rate}`.trim() === '' || !Number.isFinite(n)) {
    return null;
  }
  return isRelativeRate(rate) ? `+${n.toFixed(2)}` : n.toFixed(2);
}

export const formControlErrorKeys = (formControl: AbstractControl, onlyFirstErrorKey = true): string[] => {
  const keys =  Object.keys(formControl?.errors ?? {});
  if (onlyFirstErrorKey) {
    return keys.length ? [keys[0]] : keys
  }
  return keys;
}
export const formControlErrorMessage = (formControl: AbstractControl, errorKey: string): string => {
  const r = formControl?.errors?.[errorKey];
  if (r) {
    const f = (fieldErrorMessages as any)?.[errorKey];
    if (!!f) {
      if (typeof f == 'string') {
        return f;
      } else if (typeof f == 'function') {
        return f(r);
      }
    }
  }
  return '';
}

export const validateEmail = (email: string): boolean => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}


// =============================
// === pagination
// =============================

export const toPaginationInfo = (opt: {
  page: {
    limit: number,
    offset: number, // pageIndex
  }
  filter?: string | null,
  sorts?: SortTypes,
}): PaginationInfo => {
  return {
    limit: opt.page.limit,
    offset: opt.page.offset,   // pageIndex
    filter: opt.filter ?? null,
    sorts: opt.sorts ?? null,
    start: opt.page.limit * opt.page.offset,
  } as const;
};

export const paginationUrl = (url: string, opt: PaginationInfo): string => {
  const _url = _.trim(url ?? '');
  const urlSearchParams = new URLSearchParams();
  urlSearchParams.set('limit', `${opt.limit}`);
  urlSearchParams.set('offset', `${opt.offset}`);
  if (opt.sorts && opt.sorts.length) {
    const sorts = opt.sorts.reduce<string[]>((acc, sort) => {
      if (sort) {
        acc.push(_.lowerCase(sort.dir) == 'asc' ? sort.prop: `-${sort.prop}`);
      }
      return acc;
    }, []);
    urlSearchParams.set('sorts', sorts.join(','));
  }
  if (opt.filter) {
    urlSearchParams.set('filter', opt.filter);
  }
  return (_url.indexOf('?') > 0) ?
    `${_url}&${urlSearchParams.toString()}` :
    `${_url}?${urlSearchParams.toString()}`;
}


// ==========================
// ====  Setup untildestroy
// ==========================
export const setupUntilDestroy = (component: any) => {}
export const untilDestroyedFn = () => {
  const subject = new Subject<void>();
  const viewRef = inject(ChangeDetectorRef) as ViewRef;
  viewRef.onDestroy(() => {
    subject.next();
    subject.complete();
  });
  return takeUntil(subject.asObservable());
}


// ==========================
// ====  Angular Material UI Helper class
// ==========================
export class CustomErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

// TODO: temporary typing fix
export const getAddress2ComponentValueFormControlValueFn = (formControl: FormControl): ()=> { observable: Observable<Address2ComponentValue>, value: Address2ComponentValue } => {
  return () => {
    return { observable: formControl.valueChanges, value: formControl.value };
  }
}

// ==========================
// ====  DigitalID work
// ==========================
export const parseDigitalIdResponse = (e: DigitalIdComponentEvent): ParsedDigitalIdResponse => {
  const r: DigitalIdAuthenticationPayload = (e.authResult as any).payload;
  const address: string = r.individualInfo.address.formatted.replace('\n', ' ');
  const parsedAddress = parser.parseLocation(address);
  return {
    birthdate: r.individualInfo.birthdate,
    firstName: r.individualInfo.given_name,
    middleName: r.individualInfo.middle_name,
    lastName: r.individualInfo.family_name,
    country: r.individualInfo.address.country,
    state: r.individualInfo.address.region,
    postcode: r.individualInfo.address.postal_code,
    suburb: r.individualInfo.address.locality,
    rawAddress: r.individualInfo.address.formatted.replace('\n', ' '),
    streetName: parsedAddress.streetName ? parsedAddress.streetName : '',
    streetNumber: parsedAddress.streetNumber ? parsedAddress.streetNumber : '',
    streetType: parsedAddress.streetType ? parsedAddress.streetType : '',
    unitNumber: parsedAddress.unitNumber ? parsedAddress.unitNumber : '',
  };
};


// ==========================
// ====   Http Client utils
// ==========================
export type HttpOptions = {
  headers?: {
    [header: string]: string | string[];
  };
  context?: HttpContext;
  observe?: 'body';
  params?: HttpParams | {
    [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
}

export const httpOptions = (options?: HttpOptions) => {
  const o =  options ? {...options} : {headers: {}};
  const accessToken = getAccessToken();
  if (accessToken) {
    if (!o.headers) {
      o.headers = {};
    }
    if (!o.headers['Authorization']) {
      o.headers['Authorization'] = `Bearer ${accessToken}`;
    }
  }
  return o;
}


// ==========================
// ====   Local / Session Storage
// ==========================
export const storeTokens = (tokens: {user?: PortalLoginUser, accessToken?: string, refreshToken?: string}) => {
  if (tokens.user) {
    setIntoLocalStorage(TOKEN_GROW_USER, stringifyJSON(tokens.user));
  }
  if (tokens.refreshToken) {
    setIntoLocalStorage(TOKEN_GROW_REFRESH_TOKEN, tokens.refreshToken);
  }
  if (tokens.accessToken) {
    setIntoLocalStorage(TOKEN_GROW_ACCESS_TOKEN, tokens.accessToken);
  }
}


export const storePortalTheme = (theme: PortalTheme | null) => {
  if (theme) {
    setIntoLocalStorage(TOKEN_GROW_PORTAL_THEME, theme);
  } else {
    localStorage.removeItem(TOKEN_GROW_PORTAL_THEME);
  }
}

export const getPortalThemeFromStorage = (): PortalTheme => {
  const portalTheme =  getFromLocalStorage(TOKEN_GROW_PORTAL_THEME);
  if (portalTheme) {
    return portalTheme == 'dark' ? 'dark' : 'light';
  }
  return 'light';
}

export const storeWhitelabelIntoStorage = (w: WhitelabelEntityDetails | null) => {
  if (w) {
    setIntoLocalStorage(TOKEN_GROW_WHITELABEL, stringifyJSON(w));
  } else {
    localStorage.removeItem(TOKEN_GROW_WHITELABEL);
  }
}

export const getWhiteLabelFromStorage = (): WhitelabelEntityDetails | null => {
  return parseJSON(getFromLocalStorage(TOKEN_GROW_WHITELABEL));
}

export const getAccessToken = (): string | null => {
  return parseJSON(getFromLocalStorage(TOKEN_GROW_ACCESS_TOKEN));
}

export const getRefreshToken = (): string | null => {
  return parseJSON(getFromLocalStorage(TOKEN_GROW_REFRESH_TOKEN));
}

export const getUser = (): PortalLoginUser | null => {
  return toUser(parseJSON(getFromLocalStorage(TOKEN_GROW_USER, {returnNullIfNotJson: true})));
}

export const store2faEnteredWhenLogin = (tfaEnteredWhenLogin: boolean) => {
  // todo: better encryption? - encryption and decription must match with is2faEnteredWhenLogin
  const msg = sha256(`${getUser()?.Email??''}:${tfaEnteredWhenLogin}`).toString();
  localStorage.setItem(TOKEN_GROW_IS_2FA_ENTERED_WHEN_LOGIN, msg);
}

export const is2faEnteredWhenLogin = (): boolean => {
  // todo: better encryption? - encryption and decription must match with store2faEnteredWhenLogin
  const msg = sha256(`${getUser()?.Email??''}:${true}`).toString();
  const msgStored = localStorage.getItem(TOKEN_GROW_IS_2FA_ENTERED_WHEN_LOGIN);
  return msgStored == msg;
}

export const storeLastVisit = (user?: PortalLoginUser | null, url?: string | null) => {
  if (url) {
    setIntoLocalStorage(TOKEN_LAST_VISITED_URL, url);
  }
  if (user && user.Email) {
    setIntoLocalStorage(TOKEN_LAST_VISITED_EMAIL, user.Email);
  } else {
    localStorage.removeItem(TOKEN_LAST_VISITED_EMAIL);
  }
}

export const getLastVisitedUrl = () => {
  //m return localStorage.getItem(TOKEN_LAST_VISITED_URL);
  return getFromLocalStorage(TOKEN_LAST_VISITED_URL);
}

export const getLastVisitedEmail = () => {
  return getFromLocalStorage(TOKEN_LAST_VISITED_EMAIL);
}


export const clearStorage = () => {
  localStorage.removeItem(TOKEN_GROW_ACCESS_TOKEN);
  localStorage.removeItem(TOKEN_GROW_REFRESH_TOKEN);
  localStorage.removeItem(TOKEN_GROW_USER);
  localStorage.removeItem(TOKEN_GROW_IS_2FA_ENTERED_WHEN_LOGIN);
  localStorage.removeItem(TOKEN_GROW_WHITELABEL);
}

export const clearAllStorage = () => {
  localStorage.removeItem(TOKEN_GROW_ACCESS_TOKEN);
  localStorage.removeItem(TOKEN_GROW_REFRESH_TOKEN);
  localStorage.removeItem(TOKEN_GROW_USER);
  localStorage.removeItem(TOKEN_GROW_IS_2FA_ENTERED_WHEN_LOGIN);
  localStorage.removeItem(TOKEN_LAST_VISITED_URL);
  localStorage.removeItem(TOKEN_LAST_VISITED_EMAIL);
  localStorage.clear();
}


// ==========================
// ====   color / theme
// ==========================

export const toContrastColor = (color: string /* #ffffff or rgb(...) or rgba(...) format*/) => {
  // Convert the color to RGB then invert it
  const c = tinycolor2(color);
  if (!c.isValid()) {
    console.error(`invalid color format ${color}`);
  }
  const rgb = tinycolor2(color).toRgb();
  const invertedRgb = {
    r: 255 - rgb.r,
    g: 255 - rgb.g,
    b: 255 - rgb.b,
  };

  // Convert back to hex for use
  const toColor = tinycolor2(invertedRgb);
  return fromTinyColor2ToString(toColor, c.getFormat());
}

const fromTinyColor2ToString = (c: tinycolor2.Instance, format: string = 'hex'): string => {
  if (format == 'rgb') {
    return c.toRgbString();
  }
  return c.toHexString();
}


export const generateMaterialShades = (baseColor: string): MaterialShades => {
  const color = tinycolor2(baseColor);
  if (!color.isValid()) {
    console.error(`basecolor ${baseColor} is an invalid color`);
  }
  const shades = {
    '50': fromTinyColor2ToString(tinycolor2(color.toHex()).lighten(52)),
    '100': fromTinyColor2ToString(tinycolor2(color.toHex()).lighten(37)),
    '200': fromTinyColor2ToString(tinycolor2(color.toHex()).lighten(26)),
    '300': fromTinyColor2ToString(tinycolor2(color.toHex()).lighten(12)),
    '400': fromTinyColor2ToString(tinycolor2(color.toHex()).lighten(6)),
    '500': fromTinyColor2ToString(tinycolor2(color.toHex())), // base color
    '600': fromTinyColor2ToString(tinycolor2(color.toHex()).darken(6)),
    '700': fromTinyColor2ToString(tinycolor2(color.toHex()).darken(12)),
    '800': fromTinyColor2ToString(tinycolor2(color.toHex()).darken(18)),
    '900': fromTinyColor2ToString(tinycolor2(color.toHex()).darken(24)),
    'A100': fromTinyColor2ToString(tinycolor2(color.toHex()).lighten(50).saturate(30)),
    'A200': fromTinyColor2ToString(tinycolor2(color.toHex()).lighten(30).saturate(30)),
    'A400': fromTinyColor2ToString(tinycolor2(color.toHex()).lighten(10).saturate(15)),
    'A700': fromTinyColor2ToString(tinycolor2(color.toHex()).darken(5).saturate(10)),
  };

  return shades;
}

export const generateWhitelabelStyles = (options: {
  primary: string,
    accent: string,
    warn: string,
}): WhitelabelStyles => {
  const primaryContrast = toContrastColor(options.primary);
  const accentContrast = toContrastColor(options.accent);
  const warnContrast = toContrastColor(options.warn);
  const primaryShades = generateMaterialShades(options.primary);
  const primaryContrastShades = generateMaterialShades(primaryContrast);
  const accentShades = generateMaterialShades(options.accent);
  const accentContrastShades = generateMaterialShades(accentContrast);
  const warnShades = generateMaterialShades(options.warn);
  const warnContrastShades = generateMaterialShades(warnContrast);
  return {
    'grow-primary-palette-50': primaryShades['50'],
    'grow-primary-palette-100': primaryShades['100'],
    'grow-primary-palette-200': primaryShades['200'],
    'grow-primary-palette-300': primaryShades['300'],
    'grow-primary-palette-400': primaryShades['400'],
    'grow-primary-palette-500': primaryShades['500'],
    'grow-primary-palette-600': primaryShades['600'],
    'grow-primary-palette-700': primaryShades['700'],
    'grow-primary-palette-800': primaryShades['800'],
    'grow-primary-palette-900': primaryShades['900'],
    'grow-primary-palette-A100': primaryShades.A100,
    'grow-primary-palette-A200': primaryShades.A200,
    'grow-primary-palette-A400': primaryShades.A400,
    'grow-primary-palette-A700': primaryShades.A700,
    'grow-primary-palette-contrast-50': primaryContrastShades['50'],
    'grow-primary-palette-contrast-100': primaryContrastShades['100'],
    'grow-primary-palette-contrast-200': primaryContrastShades['100'],
    'grow-primary-palette-contrast-300': primaryContrastShades['100'],
    'grow-primary-palette-contrast-400': primaryContrastShades['100'],
    'grow-primary-palette-contrast-500': primaryContrastShades['100'],
    'grow-primary-palette-contrast-600': primaryContrastShades['100'],
    'grow-primary-palette-contrast-700': primaryContrastShades['100'],
    'grow-primary-palette-contrast-800': primaryContrastShades['100'],
    'grow-primary-palette-contrast-900': primaryContrastShades['100'],
    'grow-primary-palette-contrast-A100': primaryContrastShades.A100,
    'grow-primary-palette-contrast-A200': primaryContrastShades.A200,
    'grow-primary-palette-contrast-A400': primaryContrastShades.A400,
    'grow-primary-palette-contrast-A700': primaryContrastShades.A700,

    'grow-accent-palette-50': accentShades['50'],
    'grow-accent-palette-100': accentShades['100'],
    'grow-accent-palette-200': accentShades['200'],
    'grow-accent-palette-300': accentShades['300'],
    'grow-accent-palette-400': accentShades['400'],
    'grow-accent-palette-500': accentShades['500'],
    'grow-accent-palette-600': accentShades['600'],
    'grow-accent-palette-700': accentShades['700'],
    'grow-accent-palette-800': accentShades['800'],
    'grow-accent-palette-900': accentShades['900'],
    'grow-accent-palette-A100': accentShades.A100,
    'grow-accent-palette-A200': accentShades.A200,
    'grow-accent-palette-A400': accentShades.A400,
    'grow-accent-palette-A700': accentShades.A700,
    'grow-accent-palette-contrast-50': accentContrastShades['50'],
    'grow-accent-palette-contrast-100': accentContrastShades['100'],
    'grow-accent-palette-contrast-200': accentContrastShades['200'],
    'grow-accent-palette-contrast-300': accentContrastShades['300'],
    'grow-accent-palette-contrast-400': accentContrastShades['400'],
    'grow-accent-palette-contrast-500': accentContrastShades['500'],
    'grow-accent-palette-contrast-600': accentContrastShades['600'],
    'grow-accent-palette-contrast-700': accentContrastShades['700'],
    'grow-accent-palette-contrast-800': accentContrastShades['800'],
    'grow-accent-palette-contrast-900': accentContrastShades['900'],
    'grow-accent-palette-contrast-A100': accentContrastShades.A100,
    'grow-accent-palette-contrast-A200': accentContrastShades.A200,
    'grow-accent-palette-contrast-A400': accentContrastShades.A400,
    'grow-accent-palette-contrast-A700': accentContrastShades.A700,

    'grow-warn-palette-50': warnShades['50'],
    'grow-warn-palette-100': warnShades['100'],
    'grow-warn-palette-200': warnShades['200'],
    'grow-warn-palette-300': warnShades['300'],
    'grow-warn-palette-400': warnShades['400'],
    'grow-warn-palette-500': warnShades['500'],
    'grow-warn-palette-600': warnShades['600'],
    'grow-warn-palette-700': warnShades['700'],
    'grow-warn-palette-800': warnShades['800'],
    'grow-warn-palette-900': warnShades['900'],
    'grow-warn-palette-A100': warnShades.A100,
    'grow-warn-palette-A200': warnShades.A200,
    'grow-warn-palette-A400': warnShades.A400,
    'grow-warn-palette-A700': warnShades.A700,
    'grow-warn-palette-contrast-50': warnContrastShades['50'],
    'grow-warn-palette-contrast-100': warnContrastShades['100'],
    'grow-warn-palette-contrast-200': warnContrastShades['200'],
    'grow-warn-palette-contrast-300': warnContrastShades['300'],
    'grow-warn-palette-contrast-400': warnContrastShades['400'],
    'grow-warn-palette-contrast-500': warnContrastShades['500'],
    'grow-warn-palette-contrast-600': warnContrastShades['600'],
    'grow-warn-palette-contrast-700': warnContrastShades['700'],
    'grow-warn-palette-contrast-800': warnContrastShades['800'],
    'grow-warn-palette-contrast-900': warnContrastShades['900'],
    'grow-warn-palette-contrast-A100': warnContrastShades.A100,
    'grow-warn-palette-contrast-A200': warnContrastShades.A200,
    'grow-warn-palette-contrast-A400': warnContrastShades.A400,
    'grow-warn-palette-contrast-A700': warnContrastShades.A700,
  };
}





// ==========================
// ====   UX Unit Conversion
// ==========================

export const pxToRem = (pixel: number, base: number = 14) => {
  return `${(pixel / base)}rem`;
}

export const remToPx = (rem: number, base: number = 14) => {
  return rem * base;
}


// ==========================
// ====   CSS Variables
// ==========================
export const getCssVariableContent = (cssVariable: string): string => {
  const style = getComputedStyle(document.documentElement);
  let value = style.getPropertyValue(cssVariable);
  if (!value) { // attempt to get it from body
    const body = document.querySelector('body');
    if (body) {
      const bodyStyle = getComputedStyle(body);
      value =  bodyStyle.getPropertyValue(cssVariable);
    }
  }
  return value;
}

export const hexToRgb = (hex: string, alpha?: number): string => {
  const {red, green, blue} = hexRgb(hex);
  if (_.isNil(alpha)) {
    return `rgb(${red}, ${green}, ${blue})`;
  } else {
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
  }
}


// ==========================
// ====   Stepper utils
// ==========================
// NOTE: DEPRECATED see ApplicationStepper2Component
export const setNextButtonText = (stepFormGroup: FormGroup, nextStepButtonText: string) => {
  (stepFormGroup as any)['nextStepButtonText'] = nextStepButtonText;
}

// NOTE: DEPRECATED see ApplicationStepper2Component
export const setSecondaryButtonText = (stepFormGroup: FormGroup, nextStepButtonText: string) => {
  (stepFormGroup as any)['secondaryButtonText'] = nextStepButtonText;
}

// NOTE: DEPRECATED see ApplicationStepper2Component
export const setCurrentStepFn = (stepFormGroup: FormGroup, fn: (e: StepperSelectionEvent)=>void) => {
  (stepFormGroup as any)['currentStepFn'] = fn;
}

// NOTE: DEPRECATED see ApplicationStepper2Component
export const setSubmitStepFn = (stepFormGroup: FormGroup, fn: (s: CdkStepper)=>void) => {
  (stepFormGroup as any)['submitStepFn'] = fn;
}

// NOTE: DEPRECATED see ApplicationStepper2Component
export const setSecondaryButtonFn = (stepFormGroup: FormGroup, fn: (s: CdkStepper)=>void) => {
  (stepFormGroup as any)['secondaryButtonFn'] = fn;
}

// NOTE: DEPRECATED see ApplicationStepper2Component
export const setPrevNextButtonVisibilityFn = (stepFormGroup: FormGroup, prevVisible: boolean, nextVisible: boolean) => {
  (stepFormGroup as any)['prevStepButtonVisible'] = prevVisible;
  (stepFormGroup as any)['nextStepButtonVisible'] = nextVisible;
}


// ==========================
// ====   Field Mask
// ==========================

export const createYearInputMask = () => {
  return createMask({ mask: '9999' });
}

export const createAbnInputMask = () => {
  return createMask({ mask: '99999999999' });
}

export const createAcnInputMask = () => {
  return createMask({ mask: '999999999'});
}

export const createBsbInputMask = () => {
  return createMask({mask: '999999'});
}

export const createAccountNumberInputMask = () => {
  return createMask({
    // mask: '9999999999',
    regex: '^[0-9]{1,10}$',
    allowMinus: false,
    // digits: 0,
    rightAlign: false,
    greedy: true,
    placeholder:'',
  });
}

// ADO-817: allows accented Latin letters (e.g. "José") and a comma (e.g. "Smith, Jr") in addition
// to plain ASCII letters, so names entered as-is are not silently blocked at the keystroke.
// \u00C0-\u02AF covers Latin-1 Supplement and Latin Extended-A/B, i.e. the accented letters used by
// common European names.
export const createNameInputMask = () => {
  return createMask({
    regex: '^[a-zA-Z\u00C0-\u02AF\',\\s-]{2,30}$',
    placeholder: '',
  })
}

export const createNameIncludeDigitsInputMask = () => {
  return createMask({
    regex: '^[0-9a-zA-Z\u00C0-\u02AF\',\\s-]{2,30}$',
    placeholder: '',
  })
}

export const createDriverLicenceNumberInputMask = () => {
  return createMask({
    regex: '^[a-zA-Z0-9]{6,10}$',
    allowMinus: false,
    rightAlign: false,
    greedy: true,
    placeholder:'',
  })
}

export const createDriverLicenceCardNumberInputMask = () => {
  return createMask({
    regex: '^[a-zA-Z0-9]{6,10}$',
    allowMinus: false,
    rightAlign: false,
    greedy: true,
    placeholder:'',
  })
}

export const createCurrencyInputMask = () => {
  return createMask({
    alias: 'numeric',
    groupSeparator: ',',
    digits: 2,
    digitsOptional: false,
    rightAlign: false,
    // placeholder: '0',
  });
}

export const createNoDecimalInputMask = () => {
  return createMask({
    alias: 'numeric',
    digits: 0,
    digitsOptional: false,
    rightAlign: false,
  })
}

export const createTwoDecimalInputMask = () => {
  return createMask({
    alias: 'numeric',
    digits: 2,
    digitsOptional: false,
    rightAlign: false,
  })
}

export const createThreeDecimalInputMask = () => {
  return createMask({
    alias: 'numeric',
    digits: 3,
    digitsOptional: false,
    rightAlign: false,
  })
}

export const createMobilePhoneNumberInputMask  = () => {
  return createMask({
    // alias: 'numeric',
    // mask: '9999999999',
    regex: '04[0-9]{8,8}',
    allowMinus: false,
    digits: 0,
    rightAlign: false,
    greedy: true,
    onBeforePaste: function (pastedValue, opts) {
      const v = (pastedValue ?? '').trim();
      if (v.startsWith('+61')) {
        return v.replace('+61', '0');
      } else if (v.startsWith('61')) {
        return v.replace('61', '0');
      }
      return pastedValue;
    },
    preValidation(buffer, pos, char, isSelection, opts, maskset, caretPos, strict) {
      if (caretPos.begin === 0 && char === '0') {
        if (isSelection) {
          const positions = Array.from({ length: caretPos.end - caretPos.begin }, 
            (_, index) => caretPos.begin + index);
          return {remove: positions.reverse(), caret: 1};
        } else {
          return {caret: 1};
        }
      } else if (pos === 1 && char === '4') {
        return {caret: 2};
      }
      return true;
    },  
  })
}

export const createHexColorInputMask = () => {
  return createMask({
    regex:'#[0-9A-Fa-f]{6}',
    allowMinus: false,
    rightAlign: false,
    greedy: true,
  });
}

export const createHexOrRgbColorInputMask = () => {
  const decimalRegex = `[0-1](?:\\.[0-9])?`;
  const numRegex = `[0-9]{1,3},[0-9]{1,3},[0-9]{1,3}`;
  const hexRegex = `#[0-9A-Fa-f]{6}`;
  const rgbRegex = `rgb\\(${numRegex}\\)`;
  const rgbaRegex = `rgba\\(${numRegex},${decimalRegex}\\)`;
  return createMask({
    regex: `${rgbaRegex}|${rgbRegex}|${hexRegex}`,
    greedy: false,
  });
}

export const createUrlInputMask = () => {
  return createMask({
    regex:'http(s)*://[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}([-a-zA-Z0-9()@:%_\+.~#?&//=]*)',
  })
}

export const createPhoneNumberInputMask = () => {
  return createMask({
    regex: '0[23478][0-9]{8,8}',
    allowMinus: false,
    digits: 0,
    rightAlign: false,
    greedy: true,
  })
}

export const createEmailInputMask = () => {
  return createMask({alias: 'email'});
}

export const createDateInputMask = () => {
  return createMask({
    alias: 'datetime',
    inputFormat: 'dd/mm/yyyy',
    parser: (value: any) => {
      if (typeof value === 'string') {
        const m = moment(value, 'DD/MM/YYYY', true);
        if (m.isValid()) {
          return m;
        }
      }
      if (moment.isMoment(value)) {
        return moment(value);
      }
      return null;
    },
  })
}

export const createBillerCodeMask = () => {
  return createMask({
    regex: '^[0-9]{4,6}$',
    allowMinus: false,
    digits: 0,
    rightAlign: false,
  })
}

export const createBpayCRNMask = () => {
  return createMask({
    regex: '^[0-9]{2,20}$',
    allowMinus: false,
    digits: 0,
    rightAlign: false,
  })
}



/// =================================
// ===== FormGroup / FormControl utils
// =======================================
export const findInvalidControlsRecursive = (formToInvestigate: FormGroup | FormArray): string[] => {
  const invalidControls: string[] = [];
  const recursiveFunc = (form: FormGroup|FormArray) => {
    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      if (control) {
        if (control.invalid) {
          invalidControls.push(field);
        }
        if (control instanceof FormGroup) {
          recursiveFunc(control);
        } else if (control instanceof FormArray) {
          recursiveFunc(control);
        }
      }
    });
  };
  recursiveFunc(formToInvestigate);
  return invalidControls;
};

export const markTriggerSubject = (stepControl: FormGroup): Subject<boolean> => {
  if (!(stepControl as any)['markTrigger']) {
    (stepControl as any)['markTrigger'] = new Subject();
  }
  return  (stepControl as any)['markTrigger'];
}

// find AbstractControl errors
export const doMarkAll = (a: AbstractControl, errors: string[] = [], k: string | null = null) => {
  doMark(a);
  if (a instanceof FormGroup) {
    for (const key of Object.keys(a.controls)) {
      const c = a.controls[key];
      doMarkAll(c, errors, `${k ?? ''}${key}`);
    }
  } else if (a instanceof FormArray) {
    let i = 0;
    for (const c of a.controls) {
      doMarkAll(c, errors, `${k ?? ''} ${i}`);
      i++;
    }
  } else {
    if (a.errors) {
      for (const [errorType, error] of Object.entries(a.errors)) {
        const details = typeof error === 'object' && error !== null && 'details' in error
          ? (error as {details?: unknown}).details
          : null;
        if (Array.isArray(details) && details.every(detail => typeof detail === 'string')) {
          errors.push(...details);
        } else {
          errors.push(`${k} ${errorType}`);
        }
      }
    }
  }
  return errors;
}

export const doMark = (a: AbstractControl) => {
  a.markAllAsTouched();
  a.markAsDirty();
  a.updateValueAndValidity({emitEvent: false});
}



// =====================================================================================================================================
////////////////////////  Component related misc helper functions  //////////////////////////////////////////////////////
// =====================================================================================================================================
export const isValidAssetProductType = (productType: string): productType is AssetFinanceProductType => {
  return ['FAST DOC' , 'EASY DOC' , 'FULL DOC', ].includes(productType);
}

export const isValidBoolean = (b: string): boolean => {
  return ['true', 'false'].includes((b ?? '').toLowerCase());
}

export const applicantsThatAreIndividual = (applicant: ApplicationApplicant):
  (IndividualTrustee | IndividualMember | IndividualPartner | Exclude<SoleTraderValue, null> | Exclude<DirectorValue, null>[number])[] => {
  const r: (IndividualTrustee | IndividualMember | IndividualPartner | Exclude<SoleTraderValue, null> | Exclude<DirectorValue, null>[number])[] = [];
  if (applicant) {
    if (Array.isArray(applicant)) {
      for (const app of applicant) {
        switch (app.kind) {
          case 'Director': {
            r.push(app);
            break;
          }
          case 'Member': {
            if (app.type === 'Individual') {
              r.push(app);
            }
            break;
          }
          case 'Partner': {
            if (app.type === 'Individual') {
              r.push(app);
            }
            break;
          }
          case 'Trustee': {
            if (app.type === 'Individual') {
              r.push(app);
            }
            break;
          }
        }
      }
    } else if (applicant.kind === 'SoleTrader') {
      r.push(applicant);
    }
  }
  return r;
}

export const applicantsThatAreEntity = (applicant: ApplicationApplicant):
  (EntityTrustee | EntityMember | EntityPartner)[] => {

  const r: (EntityTrustee | EntityMember | EntityPartner)[] = [];
  if (applicant) {
    if (Array.isArray(applicant)) {
      for (const app of applicant) {
        switch(app.kind) {
          case 'Member': {
            if (app.type === 'Entity') {
              r.push(app);
            }
            break;
          }
          case 'Trustee': {
            if (app.type === 'Entity') {
              r.push(app);
            }
            break;
          }
          case 'Partner': {
            if (app.type === 'Entity') {
              r.push(app);
            }
            break;
          }
        }
      }
    }
  }
  return r;
}

export const guarantorsThatAreEntity = (guarantors: Exclude<GuarantorValue, null>): EntityGuarantor[] => {
  const r: EntityGuarantor[] = [];
  for (const guarantor of guarantors) {
    if (guarantor.type === 'Entity') {
      r.push(guarantor);
    }
  }
  return r;
}

export const guarantorsThatAreIndividual = (guarantors: Exclude<GuarantorValue, null>): IndividualGuarantor[] => {
  const r: IndividualGuarantor[] = [];
  for (const guarantor of guarantors) {
    if (guarantor.type === 'Individual') {
      r.push(guarantor);
    }
  }
  return r;
}

export const toInteflowGender = (gender?: GenderValue): 'M' | 'F' | undefined => {
  if (gender === 'Male') {
    return 'M';
  } else if (gender === 'Female') {
    return 'F';
  }
  return undefined;
}

export const toInteflowTimeAtAddress = (t: TimeInAddressValue) => {
  if (t) {
    return ((t.years ?? 0) * 12) + (t.months ?? 0);
  }
  return undefined;
}

export const toInteflowPropertyOwnerAddress = (propertyOwner: PropertyOwnerWithAddressValue) => {
  if (propertyOwner && propertyOwner.address) {
    return toInteflowAddress(propertyOwner.address);
  }
  return undefined;
}

export const toInteflowAddress = (address: Address2ComponentValue) => {
  if (address && address.address) {
    return {
      UnformattedAddress: address.address,
      StreetNumber: address.StreetNumber,
      StreetName: address.StreetName,
      StreetType: address.StreetType,
      Suburb: address.Suburb,
      State: address.State,
      Postcode: address.Postcode,
      UnitNumber: address.UnitNumber,
      IsManualInput: false,
    }
  }
  return undefined;
}

/**
 * The address step's value in the API shape. Goes through toInteflowAddress rather than reading the
 * form value directly, so the two stay field-for-field identical while both wire shapes are in use.
 */
export const toApiAddress = (address: Address2ComponentValue): ApplicationAddressApi | undefined =>
  legacyAddressToApi(toInteflowAddress(address));

export const toInteflowPreviousAddress = (t: TimeInAddressValue) => {
  if (t && t.previousAddress && t.previousAddress.address) {
    return {
      UnformattedAddress: t.previousAddress.address,
      StreetNumber: t.previousAddress?.StreetNumber,
      StreetName: t.previousAddress?.StreetName,
      StreetType: t.previousAddress?.StreetType,
      Suburb: t.previousAddress?.Suburb,
      State: t.previousAddress?.State,
      Postcode: t.previousAddress?.Postcode
    }
  }
  return undefined;
}

export const toInteflowTimeAtCurrentEmployer = (e: EmployerValue) => {
  if (e) {
    return ((e.monthsAtCurrentEmployer ?? 0)) + ((e.yearsAtCurrentEmployer ?? 0) * 12);
  }
  return undefined;
}

export const individualGarantors = (guarantors: GuarantorValue): IndividualGuarantor[] => {
  if (guarantors) {
    return guarantors.filter(g => g.type === 'Individual') as IndividualGuarantor[];
  }
  return [];
}

export type IndividualIdDocumentUpload = { name: string, files: File[], individualId?: string };

export const individualIdDocumentsOnFile = (
  documents: AzureStorageDocument[],
  individualIds: (string | number | null | undefined)[],
  name: string,
): AzureStorageDocument[] => {
  const ids = new Set(individualIds.filter(id => id != null).map(id => String(id).toLowerCase()));
  const normalizedName = name.trim().replace(/\s+/g, ' ').toLowerCase();
  return documents.filter(document => {
    const metadata = document.metadata ?? {};
    const documentIndividualId = metadata['individualid']?.toLowerCase();
    if (documentIndividualId && ids.has(documentIndividualId)) {
      return true;
    }
    const documentName = (metadata['driverslicencename'] ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
    return !!normalizedName && documentName === normalizedName;
  });
}

/**
 * The ID documents to list under an individual's upload box.
 *
 * `recorded` comes from ApplicationIndividualDocument and is authoritative - it survives a rename,
 * and it does not need blob storage to be listed. The metadata match behind it covers the two cases
 * that table cannot: a provisional row with no persisted id, and a document uploaded in this
 * session before the individuals were re-read.
 */
export const individualIdDocumentRefs = (
  recorded: IndividualIdDocument[] | undefined,
  documents: AzureStorageDocument[],
  individualIds: (string | number | null | undefined)[],
  name: string,
): UploadedDocumentRef[] => {
  const refs: UploadedDocumentRef[] = (recorded ?? []).map(document => ({
    name: document.name,
    metadata: { name: document.fileName },
  }));
  const seen = new Set(refs.map(ref => ref.name));
  for (const document of individualIdDocumentsOnFile(documents, individualIds, name)) {
    if (!seen.has(document.name)) {
      refs.push(document);
      seen.add(document.name);
    }
  }
  return refs;
}

// Gathers ID documents entered through the unified individual form (per individual).
export const collectIndividualIdDocumentUploads = (
  individuals: { firstName?: string | null, lastName?: string | null, idDocument?: UploadFileValue }[],
): IndividualIdDocumentUpload[] => {
  return individuals
    .filter(i => i.idDocument && i.idDocument.length)
    .map(i => ({
      name: `${i.firstName ?? ''} ${i.lastName ?? ''}`.trim(),
      files: [...i.idDocument!],
    }));
}

// Applies the same tags/metadata the legacy "Upload Driver Licence" step used, so the
// documents listing and the final-submission metadata fixup keep working unchanged.
export const tagIndividualIdDocumentFiles = (
  uploads: IndividualIdDocumentUpload[],
  // Both spellings, because the wizards migrate to the API shape one at a time (AZ-1475 Phase 4) and
  // this is called with whichever shape its caller holds. Drop the legacy half with the last wizard.
  individuals: {
    guid?: string, givenName?: string | null, surname?: string | null,
    id?: string | number, GivenName?: string | null, SurName?: string | null,
  }[],
  baseMetadata: { [key: string]: string },
): File[] => {
  const normalizeName = (name: string) => name.trim().replace(/\s+/g, ' ').toLowerCase();
  const identifierOf = (i: { guid?: string, id?: string | number }) => i.guid ?? i.id;
  const fullNameOf = (i: { givenName?: string | null, surname?: string | null, GivenName?: string | null, SurName?: string | null }) =>
    `${i.givenName ?? i.GivenName ?? ''} ${i.surname ?? i.SurName ?? ''}`;
  return uploads.flatMap(upload => upload.files.map(f => {
    const individual = upload.individualId
      ? individuals.find(i => identifierOf(i) === upload.individualId)
      : individuals.find(i => normalizeName(upload.name) === normalizeName(fullNameOf(i)));
    const individualId = upload.individualId ?? (individual ? identifierOf(individual) : undefined);
    (f as any).tags = ['driverslicence'];
    (f as any).metadata = {
      ...baseMetadata,
      driverslicencename: individual ? fullNameOf(individual) : upload.name,
      ...(individualId ? { individualid: individualId } : {}),
    };
    return f;
  }));
}

export const applicantsThatAreGuarantor = (applicant: ApplicationApplicant): IndividualGuarantor[] => {
  const guarantors: IndividualGuarantor[] = []
  if (applicant) {
    if (Array.isArray(applicant)) {
      for (const app of applicant) {
        switch(app.kind) {
          case 'Director': {
            const director: Exclude<DirectorValue, null>[number] = app;
            if (director.guarantor) {
              const individualGuarantor: IndividualGuarantor = {
                type: 'Individual',
                kind: director.type as any,
                title: director.title,
                firstName: director.firstName,
                lastName: director.lastName,
                personalAssets: director.personalAssets,
                personalLiabilities: director.personalLiabilities,
                propertyOwner: director.propertyOwner,
                residentialAddress: director.residentialAddress,
                dob: director.dob,
                gender: director.gender,
                email: director.email,
                mobileNumber: director.mobileNumber,
                middleName: ''
              }
              guarantors.push(individualGuarantor as any);
            }
            break;
          }
          case 'Partner': {
            const partner: Exclude<PartnerValue, null>[number] = app;
            if (partner.type === 'Individual' && partner.guarantor) {
              const individualGuarantor: IndividualGuarantor = {
                type: 'Individual',
                kind: 'WithPropertyAddress',
                title: partner.title,
                firstName: partner.firstName,
                lastName: partner.lastName,
                personalAssets: partner.personalAssets,
                personalLiabilities: partner.personalLiabilities,
                propertyOwner: partner.propertyOwner,
                residentialAddress: partner.residentialAddress,
                dob: partner.dob,
                gender: partner.gender,
                email: partner.email,
                mobileNumber: partner.mobileNumber,
                middleName: ''
              }
              guarantors.push(individualGuarantor);
            }
            break;
          }
          case 'Member': {
            const member: Exclude<MemberValue, null>[number] = app;
            if (member.type === 'Individual' && member.guarantor) {
              const individualGuarantor: IndividualGuarantor = {
                type: 'Individual',
                kind: 'WithPropertyAddress',
                title: member.title,
                firstName: member.firstName,
                lastName: member.lastName,
                personalAssets: member.personalAssets,
                personalLiabilities: member.personalLiabilities,
                propertyOwner: member.propertyOwner,
                residentialAddress: member.residentialAddress,
                dob: member.dob,
                gender: member.gender,
                email: member.email,
                mobileNumber: member.mobileNumber,
                middleName: ''
              }
              guarantors.push(individualGuarantor);
            }

            break;
          }
          case 'Trustee': {
            const trustee: Exclude<TrusteeValue, null>[number] = app;
            if (trustee.type === 'Individual' && trustee.guarantor) {
              const individualGuarantor: IndividualGuarantor = {
                type: 'Individual',
                kind: 'WithPropertyAddress',
                title: trustee.title,
                firstName: trustee.firstName,
                lastName: trustee.lastName,
                personalAssets: trustee.personalAssets,
                personalLiabilities: trustee.personalLiabilities,
                propertyOwner: trustee.propertyOwner,
                residentialAddress: trustee.residentialAddress,
                dob: trustee.dob,
                gender: trustee.gender,
                email: trustee.email,
                mobileNumber: trustee.mobileNumber,
                middleName: ''
              }
              guarantors.push(individualGuarantor);
            }
            break;
          }
        }
      }
    } else if (applicant.kind === 'SoleTrader') {
      // Sole Trader
      const soletrader: Exclude<SoleTraderValue, null> = applicant;
      if (soletrader.guarantor) {
        const individualGuarantor: IndividualGuarantor = {
          type: 'Individual',
          kind: 'WithPropertyAddress',
          title: soletrader.title,
          firstName: soletrader.firstName,
          lastName: soletrader.lastName,
          personalAssets: null,
          personalLiabilities: null,
          propertyOwner: soletrader.propertyOwner ?? false,
          residentialAddress: soletrader.residentialAddress,
          dob: soletrader.dob,
          gender: soletrader.gender,
          email: soletrader.email,
          mobileNumber: soletrader.mobile,
          middleName: ''
        }
        guarantors.push(individualGuarantor);
      }
    }
  }
  return guarantors;
}

export const categoriesApplicants = (
  // todo: temporary fix
  applicants: ApplicationApplicant
    // | (Exclude<TrusteeValue, null>[number] | Exclude<MemberValue, null>[number] | Exclude<PartnerValue, null>[number] | Exclude<DirectorValue, null>[number] | Exclude<SoleTraderValue, null>)[]
  ): {
    trustees: Exclude<TrusteeValue, null>[number][],
    members: Exclude<MemberValue, null>[number][],
    partners: Exclude<PartnerValue, null>[number][],
    directors: Exclude<DirectorValue, null>[number][],
    soletraders: Exclude<SoleTraderValue, null>[],
  } => {

  const directors: Exclude<DirectorValue, null> = [];
  const members: Exclude<MemberValue, null> = [];
  const partners: Exclude<PartnerValue, null> = [];
  const trustees: Exclude<TrusteeValue, null> = [];
  const soletraders: Exclude<SoleTraderValue, null>[] = [];
  if (applicants) {
    let app: any = applicants
    if (app.kind === 'SoleTrader') {
      const soleTrader: Exclude<SoleTraderValue, null> = app;
      soletraders.push(soleTrader);
    } else if (Array.isArray(applicants)) {
      for (const app of applicants) {
        switch (app.kind) {
          case 'Director': {
            const director: Exclude<DirectorValue, null>[number] = app;
            directors.push(director);
            break;
          }
          case 'Partner': {
            const partner: Exclude<PartnerValue, null>[number] = app;
            partners.push(partner);
            break;
          }
          case 'Member': {
            const member: Exclude<MemberValue, null>[number] = app;
            members.push(member);
            break;
          }
          case 'Trustee': {
            const trustee: Exclude<TrusteeValue, null>[number] = app;
            trustees.push(trustee);
            break;
          }
        }
      }
    }
  }
  return {
    directors, trustees, members, partners, soletraders
  };
}



// =======================================================================================================================================
// ====  Convert / Mapping :  Application to component values
// =======================================================================================================================================
export const toEntityTypeValue = (type: EntityType): EntityTypeValue => {
  if (type === 'P/L') {
    return EntityTypeOptions.find(opt => opt.type === 'company') ?? null;
  } else if (type === 'PTNR') {
    return EntityTypeOptions.find(opt => opt.type === 'partnership') ?? null;
  } else if (type === 'SLTR') {
    return EntityTypeOptions.find(opt => opt.type === 'sole-trader') ?? null;
  } else if (type === 'PTY') {
    return EntityTypeOptions.find(opt => opt.type === 'company') ?? null;
  } else if (type === 'TRST') {
    return EntityTypeOptions.find(opt => opt.type === 'trust') ?? null;
  }
  return null;
}

export const toEntityType = (entityType: EntityTypeValue): EntityType => {
  if (entityType) {
    switch(entityType.type) {
      case 'company': {
        return 'PTY';
      }
      case 'trust': {
        return 'TRST';
      }
      case 'partnership': {
        return 'PTNR';
      }
      case 'sole-trader': {
        return 'SLTR';
      }
      case 'other': {
        return 'PTY';
      }
      default: {
        return 'PTY';
      }
    }
  }
  return null;
}

export const toInteflowLegalName = (b: BusinessSearchValue) : string | null => {
  if (b && b.type === 'search-result' && b.result && b.result.entityType) {
    if (b.result.entityType.entityTypeCode === 'IND') { // sole trader
      if (Array.isArray(b.result.legalName) && b.result.legalName.length) {
        return `${b.result.legalName[0].givenName} ${b.result.legalName[0].familyName}`;
      } else {
        if (b.result.legalName) {
          return `${(b.result.legalName as any).givenName} ${(b.result.legalName as any).familyName}`;
        }
      }
    }
  }
  if (b && b.type === 'search-result' &&  b.result) {
    return b.result.organisationName;
  }
  return b?.organisationName ?? '';
}

export const toInteflowEntityTypes = (entityType: EntityTypes): 'TRST' | 'PTNR' | 'PTY' | 'SLTR' => {
  if (entityType === 'sole-trader') {
    return 'SLTR';
  } else if (entityType === 'partnership') {
    return 'PTNR';
  } else if (entityType === 'company') {
    return 'PTY';
  } else if (entityType === 'trust') {
    return 'TRST';
  }
  return 'PTY';
}

export const applicationToLegalName = (application: Application): string | null=> {
  if (application) {
    const commercialEntity = primaryEntityOf(application.parties);
    if (commercialEntity) {
      // '' rather than null, as the legacy projection coerced it. Several callers compare this
      // against a form value to decide whether the name changed.
      return commercialEntity.legalName ?? '';
    }
  }
  return null;
}

export const applicationToBusinessSearchValue = (application: Application): BusinessSearchValue => {
  if (application) {
    const commercialEntity = primaryEntityOf(application.parties);
    if (commercialEntity) {
      // The identifiers come off the same entity as the name and type. They used to be read from
      // CommercialEntities[0], which is the primary on an application the wizard built in that order and
      // is a different entity once anything has reordered them - pairing one business's name with
      // another's ABN. Four of this function's callers feed the result into the wizard's business step,
      // so that pairing could be saved back onto the application.
      if (application.CompanyDetails) {
          return {
              type: 'search-result',
              organisationName: commercialEntity.legalName ?? '',
              status: '',
              abn: commercialEntity.abn ?? '',
              acn: commercialEntity.acn ?? '',
              postcode: '',
              stateCode: '',
              entityTypeValue: toEntityTypeValue(commercialEntity.entityType ?? null),
              result: application.CompanyDetails ?? undefined,
          };
      }
      return {
         type: 'free-text',
         organisationName: commercialEntity.legalName ?? '',
         abn: commercialEntity.abn ?? '',
         acn: commercialEntity.acn ?? '',
      };
    }
  }
  return null;
}

export const applicationToPreviousBusiness = (application: Application): any => {
  if (application && application.ApplicationType !== 'InsurancePremium' && application.ApplicationType !== 'Consumer') {
    return application.PreviousBusiness;
  }
  return null;
}

/**
 * Calculates the ABN age override based on Previous Business for continuity (pricing boolean).
 * Updated to use ABR result from previousBusiness.abrResult for accurate continuity determination.
 */
export const calculateAbnAgeOverrideFromPreviousBusiness = (
  primaryAbnAgeMonths: number,
  primaryGstAgeMonths: number | undefined,
  previousBusiness: BusinessNumberSearchValue,
  companyDetails?: SearchCompanyByABNResult
): boolean | undefined => {
  if (!previousBusiness || !companyDetails) {
    return undefined;
  }

  const { abnAgeWithContinuity, gstAgeWithContinuity } = calculateContinuityAges(companyDetails, previousBusiness);

  // If both primary ages are already >= 24, no override needed
  const gstAge = primaryGstAgeMonths ?? primaryAbnAgeMonths;
  if (primaryAbnAgeMonths >= 24 && gstAge >= 24) {
    return undefined;
  }

  if (abnAgeWithContinuity >= 24 && gstAgeWithContinuity >= 24) {
    return true;
  }

  return undefined;
}

/**
 * Current GST age (months) from live ABR periods. A cancelled GST registration
 * (effectiveTo other than the ABR still-active sentinel) is age 0, even when the
 * search result still carries a naive start-date GSTAgeMonths.
 */
export const searchResultToGstAgeMonths = (
  companyDetails: SearchCompanyByABNResult | undefined | null,
  fallbackGstAgeMonths: number = 0,
): number => {
  if (!companyDetails) {
    return fallbackGstAgeMonths;
  }
  return computeAges(companyDetails).gstAgeMonths ?? fallbackGstAgeMonths;
}

/**
 * Continuity-extended GST age (months) for the BL/OD Tier 2/3 pricing input, derived from a
 * live business-search result plus the selected previous business. Tier 1 (premium) is priced
 * on the non-continuity GST age; Tier 2/3 may benefit from a prior business's trading history.
 * Falls back to the supplied non-continuity gstAgeMonths when no search result is available.
 */
export const searchResultToGstAgeMonthsWithContinuity = (
  companyDetails: SearchCompanyByABNResult | undefined | null,
  previousBusiness: BusinessNumberSearchValue | null | undefined,
  fallbackGstAgeMonths: number,
): number => {
  if (!companyDetails) {
    return fallbackGstAgeMonths;
  }
  return calculateContinuityAges(companyDetails, previousBusiness as BusinessNumberSearchValue).gstAgeWithContinuity
    ?? fallbackGstAgeMonths;
}

export const applicationToAdditionalBrokerCorrespondent = (application: Application): UserSelectionValue => {
  if (application) {
    return application.AdditionalBrokerCorrespondent;
  }
  return null;
}

export const applicationToBrokerContact = (application: Application): SalesforceContactSameAccountSelectionValue => {
  if (application) {
    return application.BrokerContact;
  }
  return null;
}

export const applicationToHasAdditionalBrokerCorrespondent = (application: Application): boolean => {
  if (application) {
    return !!application.AdditionalBrokerCorrespondent;
  }
  return false;
}

export const applicationToBrokerSearchValue = (application: Application): AggregatorSearchComponentValue => {
  if(application) {
    if (application.AppInfo &&
      application.AppInfo.BrokerSalesforceID &&
      application.AppInfo.BrokerAbn &&
      application.AppInfo.BrokerEntityName) {
      return {
        salesforceId: application.AppInfo.BrokerSalesforceID,
        abn: application.AppInfo.BrokerAbn,
        entityName: application.AppInfo.BrokerEntityName,
      }
    }
    return {
      abn: application.BrokerABN,
      salesforceId: application.BrokerSalesforceId,
      entityName: application.BrokerName,
    }
  }
  return null;
}

export const applicationToInvoiceAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Consumer':
      case 'Commercial':
        return application.PricingDetails.InvoiceAmount;
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToDepositAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Commercial':
        return application.PricingDetails.Deposit;
      case 'BusinessLoans': // not used in bussiness loan
      case 'BusinessOverdraft':
        return null;
      case 'Consumer':
        return application.PricingDetails.Deposit;
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return application.PricingDetails.Deposit;
    }
  }
  return null;
}

export const applicationToLoanAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Commercial':
      case 'CorporateLoans':
        return application.PricingDetails.LoanAmount;
      case 'Consumer':
        return application.PricingDetails.LoanAmount;
      case 'TradeFinance':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToFacilityEstablishmentFee = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'BusinessOverdraft':
      case 'CorporateLoans':
        return application.PricingDetails.FacilityEstablishmentFee
    }
  }
  return null;
}

export const applicationToAsset = (application: Application): AssetSelectionComponentValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':
        const assetCategoryIndex = application.AppInfo.AssetCategory;
        const assetCategoryTypeIndex = application.AppInfo.AssetType;
        const assetCategory = getAssetCategory(assetCategoryIndex);
        const assetCategoryType = getAssetCategoryType(assetCategoryIndex, assetCategoryTypeIndex);
        // NOTE: assetCategory or assetCategoryType is falsy, a valid asset was not entered
        if (!assetCategoryIndex || !assetCategoryTypeIndex) {
          return null;
        }

        return {
          category: assetCategory ?? {index: assetCategoryIndex, value: ''},
          type: assetCategoryType ?? {index: assetCategoryTypeIndex, value: ''},
          model: application.AssetSpec?.vehicle,
          year: String(application.AssetSpec?.year),
          family: application.AssetSpec?.family,
          make: application.AssetSpec?.make,
          description: application.AssetSpec?.description,
          OtherCar: application.AssetSpec?.OtherCar,
          truckGrossVehicleWeight: application.AssetSpec?.truckGrossVehicleWeight,
          LoanPurpose: application.AppInfo?.LoanPurpose,
          vehicletype:application.AssetSpec?.vehicletype,
          rbid:application.AssetSpec?.rbid,
          rbc:application.AssetSpec?.rbc,
          newprice:application.AssetSpec?.newprice,
          month:application.AssetSpec?.month,
          makecode:application.AssetSpec?.makecode,
          importflag:application.AssetSpec?.importflag,
          goodretail: application.AssetSpec?.goodretail,
          goodwhs: application.AssetSpec?.goodwhs,
          avgretail: application.AssetSpec?.avgretail,
          avgwhs: application.AssetSpec?.avgwhs,
          bodystyle: application.AssetSpec?.bodystyle,
          // vehicle: application.AssetSpec.vehicle,
        }
      case 'BusinessLoans': // not used
      case 'BusinessOverdraft':
        return null;
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToAssetCondition = (application: Application): AssetConditionValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':
        return { type: _.toLower(application.PricingDetails.AssetCondition) === 'used' ? 'Used' : 'New', name: ''};
      case 'BusinessLoans':  // not used
      case 'BusinessOverdraft':
        return null;
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}
export const applicationToPrivateSales = (application: Application): PrivateSaleType | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':
        return application.PricingDetails.PrivateSale;
      case 'BusinessLoans':  // not used
      case 'BusinessOverdraft':  // not used
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToTransactionValue = (application: Application): TransactionValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':
        if (application?.PricingDetails?.TransactionType) {
          const v = (TransactionValueOptions.find(opt => _.toLower(opt.type) == _.toLower(application.PricingDetails.TransactionType))) ?? null;
          return v;
        } else if (application?.PricingDetails?.PrivateSale) {
          if (_.toLower(application.PricingDetails.PrivateSale) === 'yes') {
            const v = (TransactionValueOptions.find(opt => opt.type == 'Private Sale')) ?? null;
            return v;
          } else {
            const v = (TransactionValueOptions.find(opt => opt.type == 'Dealer Sale')) ?? null;
            return v;
          }
        }
        return null;
      case 'BusinessLoans':  // not used
      case 'BusinessOverdraft':  // not used
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToLoanTerms = (application: Application): LoanTermValue | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance': {
        const f = LoanTermsOptions.find(opt => opt.type === String(application.PricingDetails.LoanTerm));
        if (!f) {
          return {type: String(application.PricingDetails.LoanTerm) as LoanTermType, name: `${application.PricingDetails.LoanTerm} months`}
        }
        return f ? f : null;
      }
      case 'CorporateLoans':
      case 'BusinessLoans':
      case 'BusinessOverdraft': {
        const f = BusinessLoanTermsOptions.find(opt => opt.type === String(application.PricingDetails.LoanTerm));
        if (!f) {
          return {type: String(application.PricingDetails.LoanTerm) as LoanTermType, name: `${application.PricingDetails.LoanTerm} months`}
        }
        return f ? f : null;
      }
      case 'Consumer': {
        const f = ConsumerLoanTermsOptions.find(opt => opt.type === String(application.PricingDetails.LoanTerm));
        if (!f) {
          return {type: String(application.PricingDetails.LoanTerm) as LoanTermType, name: `${application.PricingDetails.LoanTerm} months`}
        }
        return f ? f : null;
      }
      case 'TradeFinance':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToLoanTermsValue = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
      case 'AssetFinance':
      case 'BusinessLoans':
        const f = application.PricingDetails.LoanTerm;
        return f ? f : null;
    }
  }
  return null;
}

// for commercials
export const applicationToLoanTerms2 = (application: Application): LoanTermValue | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Commercial':
      case 'AssetFinance': {
        const f = CommercialLoanTermsOptions.find(opt => opt.type === String(application.PricingDetails.LoanTerm));
        return f ? f : null;
      }
    }
  }
  return null;
}


export const applicationToPaymentFrequency = (application: Application): PaymentFrequencyValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Commercial':
      case 'CorporateLoans':
      case 'Consumer': {
        const f = PaymentFrequencyOptions.find(opt => _.toLower(opt.type) === _.toLower(application.PricingDetails.PaymentPeriod ?? ''));
        return f ? f : null;
      }
      case 'TradeFinance':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToFinanceType = (application: Application): FinanceTypeValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':
        const f =  FinanceTypeOptions.find(opt => _.toLower(opt.name) ===  _.toLower(application.AppInfo.FinanceType));
        if (f) {
          return f;
        }
        return null;
      case 'BusinessLoans': // not used
      case 'BusinessOverdraft':
        return null;
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToDocFeeFinanced = (application: Application): boolean => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':
      case 'BusinessLoans':
        return _.toLower(application.PricingDetails.DocFeeFinanced) === 'yes';
      case 'BusinessOverdraft':
        return false;
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return false;
    }
  }
  return false;
}

export const applicationToBalloonPayment = (application: Application) => {
  switch(application.ApplicationType) {
    case 'AssetFinance':
    case 'BusinessLoans':
    case 'BusinessOverdraft':
    case 'Consumer':
      return application.PricingDetails.BalloonPayment;
  }
  return 0;
}

export const applicationToBalloonPaymentPrecentage = (application: Application): BalloonPaymentValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':
        const op = BalloonPaymentOptions.find(opt => opt.type === String(application.PricingDetails.BalloonPaymentPercentage));
        return op ? op : null;
      case 'BusinessLoans':  // not used
      case 'BusinessOverdraft':
        return null;
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToBalloonPaymentPrecentageNumber = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':
        return application.PricingDetails.BalloonPaymentPercentage;
      case 'BusinessLoans':  // not used
      case 'BusinessOverdraft':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToBrokerOriginationFee = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':
        return application.PricingDetails.BrokerOriginationFee;
      case 'BusinessLoans':  // not used
      case 'BusinessOverdraft':
        return null;
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToBrokerageAmount = (application: Application) => {
  switch(application.ApplicationType) {
    case 'AssetFinance':
    case 'BusinessLoans':
    case 'BusinessOverdraft':
    case 'CorporateLoans':
    case 'Consumer':
    case 'InsurancePremium':
      return application.PricingDetails.BrokerageAmount != null ? Number(application.PricingDetails.BrokerageAmount) : null;
  }
  return null;
}

export const applicationToBrokerage = (application: Application): BrokerageSelectionValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Consumer': {
        const op = BrokerageOptions.find(opt => Number(opt.type) === Number(application.PricingDetails.Brokerage))
        return op ? op : null;
      }
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToFacilityEstablishmentFeePercent = (application: Application): FacilityEstablishmentValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'CorporateLoans':
      {
        const facilityEstablishmentFeePercent = application.PricingDetails?.FacilityEstablishmentFeePercent ?? 0;
        const value = facilityEstablishmentFeePercent.toFixed(1); // Generating type as a string with 1 decimal
        const name = `${parseFloat(value).toFixed(2)}%`; // Generating name as a percentage with 2 decimal points
        return { type: value as FacilityEstablishmentType, name };
      }
      case 'Consumer':
      case 'TradeFinance':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToPropertyOwner = (application: Application): boolean => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Commercial':
      case 'CorporateLoans':
      case 'Consumer': {
        return _.toLower(application.PricingDetails.PropertyOwner) === 'yes';
      }
      case 'TradeFinance':
      case 'InsurancePremium':
        return false;
    }
  }
  return false;
}

export const applicationToAbnAgeAboveThresholdOverride = (application: Application): boolean | undefined => {
  if (application) {
    if (application.ApplicationType === 'AssetFinance') {
      const override = (application.PricingDetails as { AbnAgeAboveThresholdOverride?: 'Yes' | 'No' | null })?.AbnAgeAboveThresholdOverride;
      if (override === 'Yes') return true;
      if (override === 'No') return false;
      return undefined;
    }
    if (application.ApplicationType === 'BusinessLoans') {
      const override = (application.PricingDetails as { AbnAgeAboveThresholdOverride?: 'Yes' | 'No' | null })?.AbnAgeAboveThresholdOverride;
      if (override === 'Yes') return true;
      if (override === 'No') return false;
      return undefined;
    }
  }
  return undefined;
}

export const applicationToAbnAgeAboveThreshold = (application: Application): boolean => {
  if (application) {
    // Check for stored override first (only for AssetFinance and BusinessLoans)
    const override = applicationToAbnAgeAboveThresholdOverride(application);
    if (override !== undefined) {
      return override;
    }
    // Fall back to calculated value from ABN age
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'TradeFinance':
      case 'CorporateLoans':
        const abnAge = application.CompanyDetails?.ABNAgeMonths ?? 0;
        const gstAge = application.CompanyDetails?.GSTAgeMonths ?? abnAge;
        
        // If BOTH primary ABN age AND GST age are already >= 24 months, return true
        // (aligned with calculateAbnAgeOverrideFromPreviousBusiness logic)
        if (abnAge >= 24 && gstAge >= 24) {
          return true;
        }
        
        // Check for Previous Business continuity via GST age (aligned with credit flow in credit.ts)
        const previousBusiness = (application as any)?.PreviousBusiness?.result?.['australian-business-register-report'];
        if (previousBusiness && previousBusiness.type === 'result') {
          const previousBusinessGstFromDate = previousBusiness?.GSTStatusFromDate;
          if (previousBusinessGstFromDate) {
            const previousBusinessGstAgeMonths = moment().diff(previousBusinessGstFromDate, 'months');
            if (previousBusinessGstAgeMonths >= 24) {
              return true; // Has continuity via previous business GST age
            }
          }
        }
        
        return false;
      case 'Consumer':
        return false;
      case 'InsurancePremium':
        return false;
    }
  }
  return false;
}

export const applicationToCrediRateAdjustment = (application: Application): number => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Consumer':
      case 'CorporateLoans':
        return (application.PricingDetails.CreditRateAdjustment ?? 0.0);
      case 'TradeFinance':
      case 'InsurancePremium':
        return 0;
    }
  }
  return 0;
}

export const applicationToHybrid = (application: Application): boolean => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': {
        return _.toLower(application.PricingDetails.Hybrid) === 'yes';
      }
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Commercial':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium':
        return false;
    }
  }
  return false;
}

export const applicationToRateDiscount = (application: Application): number => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return (application.PricingDetails.RateDiscount ?? 0);
      default:
        return 0;
    }
  }
  return 0;
}

export const applicationToMonthlyAccountKeepingFee = (application: Application): number => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return (application.PricingDetails.MonthlyAccountKeepingFee ?? 0);
      default:
        return 0;
    }
  }
  return 0;
}

export const applicationToRepaymentPlusMonthlyAccountKeepingFee = (application: Application): number => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        const paymentFrequency = applicationToPaymentFrequency(application);
        const monthlyAccountKeepingFee = applicationToMonthlyAccountKeepingFee(application);
        const repayment = Number(application?.PricingDetails?.Repayment ?? 0);
        if (paymentFrequency?.type === 'Weekly') {
          return _.round(repayment + monthlyAccountKeepingFee / 4, 2);
        } else if (paymentFrequency?.type === 'Fortnightly') {
          return _.round(repayment + monthlyAccountKeepingFee / 2, 2);
        } else {
          return _.round(repayment + monthlyAccountKeepingFee, 2);
        }
      default:
        return 0;
    }
  }
  return 0;
}

export const applicationToRepaymentType = (application: Application) => {
  switch(application.ApplicationType) {
    case 'AssetFinance':
    case 'BusinessLoans':
    case 'Consumer':
      const f =  RepaymentTypeOptions.find(opt => _.toLower(opt.type) ===  _.toLower(application.PricingDetails.RepaymentType));
          return f ? f : null;
  }
  return null;
}

export const applicationToLastUpdatedByUser = (application: Application) => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
        return (application.PricingDetails.LastUpdatedByUser ?? null);
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Consumer':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToAdverseOnFile = (application: Application): boolean => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Consumer':
      case 'CorporateLoans':
        return (_.toLower(application.PricingDetails.AdverseOnFile) === 'yes');
      case 'TradeFinance':
      case 'InsurancePremium':
        return false;
    }
  }
  return false;
}

export const applicationToTermRenewal = (application: Application): boolean => {
  if (application) {
    switch (application.ApplicationType) {
      case 'BusinessOverdraft':
        return (application.PricingDetails.TermRenewal ?? false) === 'Yes';
    }
  }
  return false;
}

export const applicationToEarlyTerminationFee = (application: Application): number | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'BusinessOverdraft':
        return application.PricingDetails.EarlyTerminationFee ?? null;
    }
  }
  return null;
}

export const applicationToAdditionalCommission = (application: Application): boolean => {
  if (application) {
    switch (application.ApplicationType) {
      case 'BusinessOverdraft':
        return application.PricingDetails.AdditionalCommission === 'Yes';
    }
  }
  return false;
}

export const applicationToLtv = (application: Application): LtvSelectionType | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'CorporateLoans':
        return (application.PricingDetails.ltv ?? null);
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Consumer':
      case 'TradeFinance':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}


export const applicationToSecurityType = (application: Application): SecurityTypeSelectionType | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'CorporateLoans':
        return (application.PricingDetails.securityType ?? null);
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Consumer':
      case 'TradeFinance':
      case 'InsurancePremium':
        return null;
    }
  }
  return null;
}

export const applicationToEquifaxScoreAboveThreshold = (application: Application): boolean => {
  if (!application) return false;
  // Each product has its own Equifax Director Score threshold, matching the toggle label
  // shown on its pricing page. The stored EquifaxDirectorScoreThreshold string is the
  // single source of truth (historical rows were migrated by script 5.5.6-02).
  const derive = (required: '>=550' | '>=600' | '>=700'): boolean => {
    const pricing = application.PricingDetails as { EquifaxDirectorScoreThreshold?: EquifaxDirectorScoreThresholdValue };
    return thresholdMeets(pricing?.EquifaxDirectorScoreThreshold, required);
  };
  switch (application.ApplicationType) {
    case 'AssetFinance':
      return derive('>=550');
    case 'Consumer':
    case 'CorporateLoans':
      return derive('>=600');
    case 'BusinessLoans':
    case 'BusinessOverdraft':
      return derive('>=700');
    case 'TradeFinance':
    case 'InsurancePremium':
      return false;
  }
  return false;
}

/**
 * ZEN-818 follow-up: returns the raw Equifax Director Score threshold string
 * (e.g. '>=700', '<600', null) stored on PricingDetails, or null when the
 * application type has no pricing threshold (Trade / Insurance).
 */
export const applicationToEquifaxDirectorScoreThreshold = (application: Application): EquifaxDirectorScoreThresholdValue => {
  if (!application) return null;
  switch (application.ApplicationType) {
    case 'AssetFinance':
    case 'BusinessLoans':
    case 'BusinessOverdraft':
    case 'Consumer':
    case 'CorporateLoans': {
      const stored = (application.PricingDetails as { EquifaxDirectorScoreThreshold?: EquifaxDirectorScoreThresholdValue })?.EquifaxDirectorScoreThreshold;
      return stored ?? null;
    }
    case 'TradeFinance':
    case 'InsurancePremium':
      return null;
  }
  return null;
}

/**
 * ZEN-818 follow-up: boolean-form helper so existing AF/Consumer/Corporate call sites
 * can preserve their current boolean semantic by passing the threshold they require.
 *   AF                → '>=550'
 *   Corporate / Consumer → '>=600'
 *   BL / OD           → '>=700'
 */
export const applicationToEquifaxDirectorScoreMeetsThreshold = (
  application: Application,
  required: '>=500' | '>=550' | '>=600' | '>=700',
): boolean => {
  const stored = applicationToEquifaxDirectorScoreThreshold(application);
  return thresholdMeets(stored, required);
}

/**
 * ZEN-818 follow-up: reads CompanyDetails.GSTAgeMonths (NOT the with-continuity variant)
 * for use as the TIB input to the BL/OD tier resolver.
 */
export const applicationToGstAgeMonths = (application: Application): number => {
  if (!application) return 0;
  switch (application.ApplicationType) {
    case 'AssetFinance':
    case 'BusinessLoans':
    case 'BusinessOverdraft':
    case 'TradeFinance':
    case 'CorporateLoans':
      return application.CompanyDetails?.GSTAgeMonths ?? 0;
    case 'Consumer':
    case 'InsurancePremium':
      return 0;
  }
  return 0;
}

/**
 * ZEN-818 follow-up: reads CompanyDetails.GSTAgeMonthsWithContinuity (the continuity-extended
 * GST age) for use as the Tier 2/3 input to the BL/OD tier resolver. Falls back to the
 * non-continuity GSTAgeMonths when the with-continuity value has not been persisted
 * (older applications), so the resolver still receives a sensible figure.
 */
export const applicationToGstAgeMonthsWithContinuity = (application: Application): number => {
  if (!application) return 0;
  switch (application.ApplicationType) {
    case 'AssetFinance':
    case 'BusinessLoans':
    case 'BusinessOverdraft':
    case 'TradeFinance':
    case 'CorporateLoans':
      return application.CompanyDetails?.GSTAgeMonthsWithContinuity
        ?? application.CompanyDetails?.GSTAgeMonths
        ?? 0;
    case 'Consumer':
    case 'InsurancePremium':
      return 0;
  }
  return 0;
}

export const applicationToDirectorScore = (application: Application): boolean => {
  if (application) {
    switch(application.ApplicationType) {
      case 'BusinessOverdraft':
      case 'BusinessLoans':
      case 'CorporateLoans':
        return _.toLower(application.PricingDetails.DirectorScoreRate) === 'yes';
      case 'TradeFinance':
      case 'InsurancePremium':
        return false;
    }
  }
  return false;
}

export const applicationToOrganisationType = (application: Application): EntityTypeValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Commercial':
        const commercialEntity = primaryEntityOf(application.parties);
        if (commercialEntity) {
          if (commercialEntity.entityType === 'PTY') {
            const t = EntityTypeOptions.find(opt => opt.type === 'company');
            return t ? t : null;
          } else if (commercialEntity.entityType === 'P/L') {
            const t = EntityTypeOptions.find(opt => opt.type === 'other');
            return t ? t : null;
          } else if (commercialEntity.entityType === 'PTNR') {
            const t = EntityTypeOptions.find(opt => opt.type === 'partnership');
            return t ? t : null;
          } else if (commercialEntity.entityType === 'TRST') {
            const t = EntityTypeOptions.find(opt => opt.type === 'trust');
            return t ? t : null;
          } else if (commercialEntity.entityType === 'SLTR') {
            const t = EntityTypeOptions.find(opt => opt.type === 'sole-trader');
            return t ? t : null;
          }
        }
        return null;
      case 'Consumer':
        return null;
    }
  }
  return null;
}

export const applicationToAbn = (application: Application): string | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Commercial':
        const commercialEntity = primaryEntityOf(application.parties);
        // No coercion needed: the guard is a truthiness test, which rejects the legacy projection's
        // '' and the API shape's null alike, so both fall through to the null below.
        if (commercialEntity && commercialEntity.abn) {
          return commercialEntity.abn;
        }
        return null;
      case 'Consumer':
        return null;
    }
  }
  return null;
}

export const applicationToAcn = (application: Application): string | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Commercial':
        const commercialEntity = primaryEntityOf(application.parties);
        if (commercialEntity && commercialEntity.acn) {
          return commercialEntity.acn;
        }
        return null;
      case 'Consumer':
        return null;
    }
  }
  return null;
}

export const applicationToRevenue = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Commercial':
        const commercialEntity = primaryEntityOf(application.parties);
        if (commercialEntity) {
          // 0 rather than null: the legacy projection coerced a missing revenue to 0, and this feeds a
          // currency form control.
          return commercialEntity.revenue ?? 0;
        }
        return null;
      case 'Consumer':
        return null;
    }
  }
  return null;
}

export const applicationToPrimaryIndustry = (application: Application): PrimaryIndustrySelectionValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Commercial':
        const commercialEntity = primaryEntityOf(application.parties);
        // The three industry readers keep their truthiness guards, which treat the legacy shape's
        // undefined and the API shape's null the same way. The values themselves are the same stored
        // JSON objects under both, carried through industryDetails.
        if (commercialEntity && commercialEntity.industry?.industryDivision) {
          // The same stored JSON either way. The cast is only because the legacy CommercialEntity type
          // asserted the selection shape on these fields while the API shape types them as JsonObject
          // - the same assertion attachApplicationParties makes when it hydrates the legacy array.
          const i = commercialEntity.industry.industryDivision as unknown as PrimaryIndustrySelectionValue;
          return i ? i : null;
        }
        return null;
      case 'Consumer':
        return null;
    }
  }
  return null;
}

export const applicationToIndustrySector = (application: Application): SecondaryIndustrySelectionValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Commercial':
        const commercialEntity = primaryEntityOf(application.parties);
        if (commercialEntity && commercialEntity.industry?.industryGroup) {
          const i = commercialEntity.industry.industryGroup as unknown as SecondaryIndustrySelectionValue;
          return i ? i : null;
        }
        return null;
      case 'Consumer':
        return null;
    }
  }
  return null;
}

export const applicationToSubdivisionIndustrySector = (application: Application): SubdivisionIndustrySelectionValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Commercial':
        const commercialEntity = primaryEntityOf(application.parties);
        if (commercialEntity && commercialEntity.industry?.industryClassDetail) {
          const i = commercialEntity.industry.industryClassDetail as unknown as SubdivisionIndustrySelectionValue;
          return i ? i : null;
        }
        return null;
      case 'Consumer':
        return null;
    }
  }
  return null;
}

export const applicationToPrimaryAddress = (application: Application): Address2ComponentValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Commercial':
        const commercialEntity = primaryEntityOf(application.parties);
        if (commercialEntity) {
          // Same as applicationToApplicantResidentialAddress: the legacy projection substituted an
          // all-blank address when the entity had no principal-place-of-business row, so the second
          // half of this guard was always true and every field was already ''. Coerce here and drop
          // the unreachable `?? parseRawAddress(...)` fallbacks rather than let the API shape's nulls
          // switch them on, which would prefill parsed fragments into a business address nobody
          // entered. UnitNumber keeps the parsed value, having never read the row.
          const principalPlace = commercialEntity.principalPlaceOfBusiness;
          const parsedAddress = parseRawAddress(principalPlace?.unformattedAddress ?? '');
          return {
            address: principalPlace?.unformattedAddress ?? '',
            UnitNumber: parsedAddress?.unit_number ?? '',
            StreetNumber: principalPlace?.streetNumber ?? '',
            StreetName: principalPlace?.streetName ?? '',
            StreetType: principalPlace?.streetType ?? '',
            Suburb: principalPlace?.suburb ?? '',
            State: principalPlace?.state ?? '',
            Postcode: principalPlace?.postcode ?? '',
          }
        }
        return null;
      case 'Consumer':
        return null;
    }
  }
  return null;
}

/**
 * Registered office of the primary entity, as re-shown on the company details step of a reopened
 * draft. Prefilled there from the KYB run but broker-editable, so the saved value wins.
 */
export const applicationToRegisteredBusinessAddress = (application: Application): Address2ComponentValue => {
  const commercialEntity = application ? primaryEntityOf(application.parties) : null;
  const address = commercialEntity?.registeredBusinessAddress;
  // Unlike the two readers above, this guard already handled the missing case correctly: the legacy
  // projection's blank substitute has an empty UnformattedAddress, so it failed this test and returned
  // null, exactly as an absent address does under the API shape.
  if (!address?.unformattedAddress) {
    return null;
  }
  const parsedAddress = parseRawAddress(address.unformattedAddress);
  return {
    address: address.unformattedAddress,
    UnitNumber: parsedAddress?.unit_number ?? '',
    StreetNumber: address.streetNumber ?? '',
    StreetName: address.streetName ?? '',
    StreetType: address.streetType ?? '',
    Suburb: address.suburb ?? '',
    State: address.state ?? '',
    Postcode: address.postcode ?? '',
  };
}

/**
 * Whether a reopened draft prefills this individual into the borrower-side applicant forms
 * (directors, partners, trustees, sole trader): the applicant, or someone holding a role on the
 * borrower entity itself. Guarantors stay excluded via the Role shim so the list remains the
 * complement of applicationToGuarantors'.
 *
 * A person linked only to another entity - a signer of a corporate guarantor added from its KYB -
 * is excluded too. The forms have no way to say "not of the borrower", so the next draft save
 * would write them back as a borrower director who signs.
 */
const isBorrowerApplicantParty = (individual: ApplicationIndividual): boolean =>
  individualRoleType(individual) !== 'Guarantor'
  && (individual.isApplicant || individual.roles.some(role => role.isPrimaryRole));

// trade finance
export const applicationToDirectors = (application: Application): DirectorValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'TradeFinance':
      case 'CorporateLoans':
        const directors: NonNullable<DirectorValue> = [];
        for (const individual of (application.parties?.individuals ?? [])) {
          if (isBorrowerApplicantParty(individual)) { // Director
            const title = TitleOptions.find(
              opt => _.toLower(opt.type.toString()) === _.toLower(individual.title?.toString())
            );
            const director: Exclude<DirectorValue, null>[number] = {
              title: title ? title : null,
              email: individual.email ?? '',
              dob: moment(individual.dateOfBirth ?? '', 'YYYY-MM-DD'),
              firstName: individual.givenName ?? '',
              middleName: individual.middleName ?? '',
              lastName: individual.surname ?? '',
              mobileNumber: individual.mobileNumber ?? '',
              propertyOwner: propertyOwnerFromApiIndividual(individual),
              residentialAddress: homeAddressFormValue(individual),
              kind: 'Director',
              type: (individual.property.isOwner ? 'WithPropertyAddress' : 'WithoutPropertyAddress') as any,
              guarantor: individual.isGuarantor,
              // Empty rather than mapped, because that is what this has returned since AZ-1473: the
              // normalised individual has no assets or liabilities columns, so the legacy projection
              // never populated the arrays the two mapping helpers read and both returned []. Left
              // empty rather than fixed here - whether those figures are still wanted is a product
              // question, recorded in docs/az-1475-party-model.md.
              personalAssets: {total: 0, assets: []},
              personalLiabilities: {total: 0, liabilities: []},
              ...individualFormExtrasFromApiIndividual(individual),
            }
            directors.push(director);
          }
        }
        return directors.length ? directors : null;
    }
  }
  return null;
}

/**
 * The residential address as the role forms take it.
 *
 * Unconditional and coerced field by field, because the legacy projection substituted an all-blank
 * address for an individual with no address row: the `HomeAddress ? ... : null` ternary every one of
 * these readers used to carry could not take its null branch, and each field was already ''. The API
 * shape leaves `homeAddress` null, so without this a missing address would prefill nulls into form
 * controls the broker then saves.
 */
const homeAddressFormValue = (individual: ApplicationIndividual): Address2ComponentValue => {
  const homeAddress = individual.homeAddress;
  return {
    address: homeAddress?.unformattedAddress ?? '',
    StreetNumber: homeAddress?.streetNumber ?? '',
    StreetName: homeAddress?.streetName ?? '',
    StreetType: homeAddress?.streetType ?? '',
    Suburb: homeAddress?.suburb ?? '',
    State: homeAddress?.state ?? '',
    UnitNumber: homeAddress?.unitNumber ?? '',
    Postcode: homeAddress?.postcode ?? '',
  };
};

/**
 * The property-owner value in the shape the guarantor, partner, trustee and sole-trader forms take,
 * which is `{ propertyOwner: false }` where the director form takes the boolean `false`. The two are
 * not interchangeable, which is why propertyOwnerFromApiIndividual below stays separate.
 *
 * `?? undefined` on the two amounts, not `?? null`: the legacy projection coerced them that way and
 * they feed currency controls.
 */
const propertyOwnerValueFromApiIndividual = (individual: ApplicationIndividual): NonNullable<PropertyOwnerWithAddressValue> => {
  if (!individual.property.isOwner) {
    return { propertyOwner: false };
  }
  const address = individual.property.address;
  return {
    propertyOwner: true,
    propertyValue: individual.property.value ?? undefined,
    mortgageValue: individual.property.mortgageBalance ?? undefined,
    address: {
      address: address?.unformattedAddress ?? '',
      StreetNumber: address?.streetNumber ?? '',
      StreetName: address?.streetName ?? '',
      StreetType: address?.streetType ?? '',
      Suburb: address?.suburb ?? '',
      State: address?.state ?? '',
      UnitNumber: address?.unitNumber ?? '',
      Postcode: address?.postcode ?? '',
    },
  };
};

const individualFormExtrasFromApiIndividual = (individual: ApplicationIndividual) => {
  return {
    hasAlias: !!individual.hasAlias,
    aliasNames: individual.aliasNames ?? null,
    countryOfCitizenship: countryOfCitizenshipByName(individual.countryOfCitizenship),
    // The legacy pair of flat keys required both to be set, and the API shape drops the object on
    // the same condition, so the same individuals get an identification either way.
    identification: (individual.identification?.type && individual.identification?.number) ? {
      idType: individual.identification.type,
      idNumber: individual.identification.number,
    } : null,
  };
}

// As above, but yielding the boolean false the director form takes for someone who owns no property.
const propertyOwnerFromApiIndividual = (individual: ApplicationIndividual): PropertyOwnerWithAddressValue | boolean => {
  return individual.property.isOwner ? propertyOwnerValueFromApiIndividual(individual) : false;
}


export const applicationToPrivacyConfirmation = (application: Application): boolean => {
  switch(application.ApplicationType) {
    case 'AssetFinance':
    case 'BusinessLoans':
    case 'BusinessOverdraft':
    case 'InsurancePremium':
    case 'Commercial':
    case 'TradeFinance':
    case 'CorporateLoans':
    case 'Consumer': {
      return yesNoToBoolean(application.AppInfo?.PrivacyConfirmation ?? 'No');
    }
  }
}

export const applicationToApplicants = (application: Application): DirectorValue | SoleTraderValue | MemberValue | PartnerValue | TrusteeValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'Commercial':
      case 'TradeFinance':
      case 'CorporateLoans':
        const commercialEntity = primaryEntityOf(application.parties);
        if (commercialEntity && commercialEntity.entityType) {
          if (commercialEntity.entityType === 'PTY') {
            const t = EntityTypeOptions.find(opt => opt.type === 'company');
            if (t) {
              const directors: NonNullable<DirectorValue> = [];
              for (const individual of (application.parties?.individuals ?? [])) {
                // KYB key people are owned by the Key People step. This shape would send each one
                // back as a director who signs, whatever KYB says they are.
                if (isBorrowerApplicantParty(individual) && !isKybSourcedParty(individual.source)) { // Director
                  const title = TitleOptions.find(
                    opt => _.toLower(opt.type.toString()) === _.toLower(individual.title?.toString())
                  );
                  const director: Exclude<DirectorValue, null>[number] = {
                    guid: individual.guid,
                    title: title ? title : null,
                    email: individual.email ?? '',
                    dob: moment(individual.dateOfBirth ?? '', 'YYYY-MM-DD'),
                    firstName: individual.givenName ?? '',
                    middleName: individual.middleName ?? '',
                    lastName: individual.surname ?? '',
                    mobileNumber: individual.mobileNumber ?? '',
                    propertyOwner: propertyOwnerFromApiIndividual(individual),
                    residentialAddress: homeAddressFormValue(individual),
                    kind: 'Director',
                    // Keyed on the address, where applicationToDirectors keys the same field on the
                    // ownership flag. Preserved: the legacy projection left AddressofPropertyOwned
                    // undefined when there was no row, which is what property.address being null says.
                    type: (!!individual.property.address ? 'WithPropertyAddress' : 'WithoutPropertyAddress') as any,
                    guarantor: individual.isGuarantor,
                    personalAssets: null,
                    personalLiabilities: null,
                    ...individualFormExtrasFromApiIndividual(individual),
                  }
                  directors.push(director);
                }
              }
              return directors.length ? directors : null;
            }
          } else if (commercialEntity.entityType === 'PTNR') {
            const t = EntityTypeOptions.find(opt => opt.type === 'partnership');
            if (t) {
              const partners: NonNullable<PartnerValue> = [];

              // individuals
              for (const individual of (application.parties?.individuals ?? [])) {
                if (isBorrowerApplicantParty(individual)) {  // Partner
                  const title = TitleOptions.find(
                    opt => _.toLower(opt.type.toString()) === _.toLower(individual.title?.toString())
                  );
                  const partner: NonNullable<PartnerValue>[number] = {
                    kind: 'Partner',
                    type: 'Individual',
                    guid: individual.guid,
                    title: title ? title : null,
                    email: individual.email ?? '',
                    dob: moment(individual.dateOfBirth ?? '', 'YYYY-MM-DD'),
                    firstName: individual.givenName ?? '',
                    lastName: individual.surname ?? '',
                    middleName: individual.middleName ?? '',
                    mobileNumber: individual.mobileNumber ?? '',
                    propertyOwner: propertyOwnerValueFromApiIndividual(individual),
                    residentialAddress: homeAddressFormValue(individual),
                    guarantor: individual.isGuarantor,
                    personalLiabilities: null,
                    personalAssets: null,
                    ...individualFormExtrasFromApiIndividual(individual),
                  }
                  partners.push(partner);
                }
              }

              // entities
              for (const entity of (application.parties?.commercialEntities ?? [])) {
                if (commercialEntityRoleType(entity) === 'Partner') {
                  // LegalName first: entities added on the KYB step carry no trading name, and
                  // reading a blank one here lets the next save write it back as the legal name.
                  // The trailing '' keeps the legacy projection's coercion, which made this '' rather
                  // than null when the entity had neither name.
                  const partnerName = entity.legalName || entity.tradingName || '';
                  const partner: NonNullable<PartnerValue>[number] = {
                    type: 'Entity',
                    kind: 'Partner',
                    acn: entity.acn ?? '',
                    abn: entity.abn ?? '',
                    organisationType: toEntityTypeValue(entity.entityType ?? null)!,
                    manualEntry: entity.manualEntry ?? false,
                    organisation: { name: partnerName, displayName: partnerName, acn: entity.acn ?? '',  abn: entity.abn ?? '', },
                  };
                  partners.push(partner);
                }
              }

              return partners.length ? partners : null;
            }
          } else if (commercialEntity.entityType === 'TRST') {
            const t = EntityTypeOptions.find(opt => opt.type === 'trust');
            if (t) {
              const trustees: NonNullable<TrusteeValue> = [];
              // individuals
              for (const individual of (application.parties?.individuals ?? [])) {
                if (isBorrowerApplicantParty(individual)) {  // Trustee
                  const title = TitleOptions.find(
                    opt => _.toLower(opt.type.toString()) === _.toLower(individual.title?.toString())
                  );
                  const trustee: NonNullable<TrusteeValue>[number] = {
                    type: 'Individual',
                    kind: 'Trustee',
                    guid: individual.guid,
                    title: title ? title : null,
                    email: individual.email ?? '',
                    dob: moment(individual.dateOfBirth ?? '', 'YYYY-MM-DD'),
                    firstName: individual.givenName ?? '',
                    lastName: individual.surname ?? '',
                    middleName: individual.middleName ?? '',
                    mobileNumber: individual.mobileNumber ?? '',
                    propertyOwner: propertyOwnerValueFromApiIndividual(individual),
                    residentialAddress: homeAddressFormValue(individual),
                    guarantor: individual.isGuarantor,
                    personalLiabilities: null,
                    personalAssets: null,
                    ...individualFormExtrasFromApiIndividual(individual),
                  }
                  trustees.push(trustee);
                }
              }


              // entities
              for (const entity of (application.parties?.commercialEntities ?? [])) {
                if (commercialEntityRoleType(entity) === 'Trustee') {
                  // LegalName first: entities added on the KYB step carry no trading name, and
                  // reading a blank one here lets the next save write it back as the legal name.
                  const trusteeName = entity.legalName || entity.tradingName || '';
                  const trustee: NonNullable<TrusteeValue>[number] = {
                    type: 'Entity',
                    kind: 'Trustee',
                    acn: entity.acn ?? '',
                    abn: entity.abn ?? '',
                    manualEntry: entity.manualEntry ?? false,
                    organisationType: toEntityTypeValue(entity.entityType ?? null)!,
                    organisation: { name: trusteeName, displayName: trusteeName, acn: entity.acn ?? '',  abn: entity.abn ?? '', },
                  };
                  trustees.push(trustee);
                }
              }

              return trustees.length ? trustees : null;
            }
          } else if (commercialEntity.entityType === 'SLTR') {
            const t = EntityTypeOptions.find(opt => opt.type === 'sole-trader');
            if (t) {

              for (const individual of (application.parties?.individuals ?? [])) {
                if (isBorrowerApplicantParty(individual)) {  // SoleTrader
                  const title = TitleOptions.find(
                    opt => _.toLower(opt.type.toString()) === _.toLower(individual.title?.toString())
                  );
                  const soleTrader: SoleTraderValue = {
                    kind: 'SoleTrader',
                    guid: individual.guid,
                    title: title ? title : null,
                    residentialAddress: homeAddressFormValue(individual),
                    dob: moment(individual.dateOfBirth ?? '', 'YYYY-MM-DD'),
                    firstName: individual.givenName ?? '',
                    lastName: individual.surname ?? '',
                    propertyOwner: propertyOwnerValueFromApiIndividual(individual),
                    guarantor: individual.isGuarantor,
                    email: individual.email ?? '',
                    mobile: individual.mobileNumber ?? '',
                    middleName: individual.middleName ?? '',
                    ...individualFormExtrasFromApiIndividual(individual),
                  };
                  // Returns the first match rather than collecting: a sole trader application has one.
                  return soleTrader;
                }
              }
            }
          }
        }
        return null;
      case 'Consumer':  // not applicable
        return null;
    }
  }
  return null;
}


/**
 * Fold the Additional Guarantors step's guarantor/signer ticks and added parties into the Key
 * People payload.
 *
 * Both steps write through the same Key People model and the save is a full sync — a stakeholder
 * absent from the payload is deselected, and a party absent from it is soft-deleted — so sending
 * one step's contribution alone would clear the other's. The two cover disjoint entities (a
 * guarantor's trustees hang off the guarantor, never off a borrowing entity), so a plain union is
 * enough.
 */
export const mergeGuarantorKybSelections = (
  keyPeople: KybKeyPeopleValue,
  guarantorSelections: GuarantorKybSelectionsEvent | null,
): KybKeyPeopleValue => {
  if (!guarantorSelections) {
    return keyPeople;
  }
  return {
    ...keyPeople,
    selections: [...keyPeople.selections, ...guarantorSelections.selections],
    selectedStakeholderIds: [...new Set([
      ...keyPeople.selectedStakeholderIds,
      ...guarantorSelections.selectedStakeholderIds,
    ])],
    addedParties: [...keyPeople.addedParties, ...guarantorSelections.addedParties],
    manualEntities: [
      ...(keyPeople.manualEntities ?? []),
      ...guarantorSelections.manualEntities,
    ],
  };
};

export const applicationToGuarantors = (application: Application): GuarantorValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'Commercial':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'CorporateLoans': {
        const guarantors: NonNullable<GuarantorValue> = [];
        for (const individual of (application.parties?.individuals ?? [])) {
          // A key person ticked as a guarantor on the Key People (KYB) step is saved with
          // Role 'Guarantor' too - their business role lives on a role row linked to their own
          // entity, which the legacy Role derivation only reads for the primary borrower. They
          // belong to that step, so reopening a draft must not list them here as well.
          //
          // The shim keeps that derivation rather than reading isGuarantor: this list must stay the
          // complement of applicationToDirectors', so a guarantor who also holds a business role
          // continues to appear only under that role. Reading the flag would list them twice.
          //
          // Same for a trustee/partner: they guarantee through the trust or partnership and are listed
          // under it, and the save keeps them while that role stands, so a row here could not be removed.
          const isTrusteeOrPartner = (individual.roles ?? []).some(role => role.isTrustee || role.isPartner);
          if (individualRoleType(individual) === 'Guarantor' && !isKybSourcedParty(individual.source) && !isTrusteeOrPartner) {
            const title = TitleOptions.find(
              opt => _.toLower(opt.type.toString()) === _.toLower(individual.title?.toString())
            );
            const g: IndividualGuarantor = {
              type: 'Individual',
              kind: 'WithPropertyAddress',
              title: title ? title : null,
              email: individual.email ?? '',
              dob: moment(individual.dateOfBirth ?? '', 'YYYY-MM-DD'),
              firstName: individual.givenName ?? '',
              lastName: individual.surname ?? '',
              middleName: individual.middleName ?? '',
              mobileNumber: individual.mobileNumber ?? '',
              // The object form, not propertyOwnerFromApiIndividual's boolean.
              propertyOwner: propertyOwnerValueFromApiIndividual(individual),
              residentialAddress: homeAddressFormValue(individual),
              personalAssets: null,
              personalLiabilities: null,
              ...individualFormExtrasFromApiIndividual(individual),
            }
            guarantors.push(g);
          }
        }
        for (const commercial of (application.parties?.commercialEntities ?? [])) {
          // commercialEntityRoleType is the same derivation the legacy Type string came from -
          // primary first, then the first trustee/partner edge, everything else 'Guarantor' - so
          // this selects exactly the entities the string test did, including the stored 'Member' and
          // 'Secondary' types that already read back as guarantors.
          if (commercialEntityRoleType(commercial) === 'Guarantor') {
            const g: EntityGuarantor = {
              type: 'Entity',
              organisationType: toEntityTypeValue(commercial.entityType ?? null)!,
              abn: commercial.abn ?? '',
              acn: commercial.acn ?? '',
              organisation: {acn: commercial.acn ?? '', abn: commercial.abn ?? '', name: commercial.legalName ?? '', displayName: commercial.legalName ?? '' },
            }
            guarantors.push(g);
          }
        }
        return guarantors.length ? guarantors : null;
      }
      case 'InsurancePremium': {
        return null;
      }
      case 'TradeFinance':
      case 'Consumer': {
        return null;
      }
    }
  }
  return null;
}

export const applicationToPrimaryContact = (application: Application): ContactValue | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'Commercial':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Consumer': {
        if(application.Contacts && application.Contacts.GivenName && application.Contacts.SurName && application.Contacts.Email){
        // Ensure Individuals exist and find the desired individual

          return {
            isManual: application.Contacts.isManual,
            title:  TitleSelectionValueOptions.find(option => option.type === application.Contacts.Title) || null,
            firstName: application.Contacts.GivenName,
            lastName: application.Contacts.SurName,
            mobileNumber: application.Contacts.Mobile,
            telephone: application.Contacts.Telephone,
            email: application.Contacts.Email,
            areaCode: application.Contacts.AreaCode,
            
          }
        }else {
          return null
        }
      }
    }
  }
  return null; // Return null if the application is invalid
};

export const applicationToBrokerFlowDocumentId = (application: Application): string | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'CorporateLoans': {
        return application.AppInfo.BrokerflowDocumentID ?? null;
      }
      case 'Consumer': {
        return null;
      }
      case 'InsurancePremium': {
        return null;
      }
      case 'TradeFinance':
    }
  }
  return null;
}

export const applicationToReferences = (application: Application): ReferenceValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'Consumer':
      case 'Commercial':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'InsurancePremium': {
        return null;
      }
    }
  }
  return null;
}


export const applicationToLoanPurpose = (application: Application): LoanPurposeValue | null => {
  if (application) {
    return application.AppInfo.LoanPurpose ?? null;
  }
  return null;
}

export const applicationToAssetCategoryType = (application: Application): AssetCategoryTypeSelectionValue => {
  switch(application.ApplicationType) {
    case 'AssetFinance':  // not used (commercial app is asset finance)
    case 'Commercial':
      const index = application.AppInfo.AssetType;
      return {index, value: ''};
    case 'BusinessLoans':
    case 'BusinessOverdraft': {
      return null;
    }
    case 'Consumer': {
      return null;
    }
    case 'InsurancePremium': {
      return null;
    }
    case 'TradeFinance':
    case 'CorporateLoans':
  }
  return null;
}

export const applicationToAssetDescription = (application: Application): string | null => {

  switch(application.ApplicationType) {
    case 'AssetFinance':  // not used (commercial app is asset finance)
    case 'Commercial':
      return application.AssetSpec?.description ?? null;
    case 'BusinessLoans':
    case 'BusinessOverdraft': {
      return null;
    }
    case 'Consumer': {
      return null;
    }
    case 'InsurancePremium': {
      return null;
    }
    case 'TradeFinance':
    case 'CorporateLoans':
  }
  return null;
}

export const applicationToApplicantTitle = (application: Application): TitleSelectionValue | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer': {
        const applicant = applicantOf(application.parties);
        if (applicant) {
          const t = TitleOptions.find(
            opt => _.toLower(opt.type.toString()) === _.toLower(applicant.title?.toString())
          );
          return t ? t : null;
        }
      }
    }
  }
  return null;
}

export const applicationToApplicantFirstName = (application: Application): string | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': {  // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          // '' rather than null: the legacy projection coerced every missing name field to '', so
          // that is what this has always handed the form control. The API shape keeps null.
          return applicant.givenName ?? '';
        }
      }
    }
  }
  return null;
}

export const applicationToApplicantLastName = (application: Application): string | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': {  // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          return applicant.surname ?? '';
        }
      }
    }
  }
  return null;
}

export const applicationToApplicantIdentification = (application: Application): IdentificationComponentValue | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': {  // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          // Rebuilt rather than passed through: the API shape names these type/number. The casts keep
          // undefined where the legacy projection put undefined - it built this object with
          // `?? undefined` while the API one uses `?? null` - so the value handed to the form is
          // unchanged. Both projections omit the object entirely on the same condition.
          return applicant.identification
            ? {
              idType: (applicant.identification.type ?? undefined) as string,
              idNumber: (applicant.identification.number ?? undefined) as string,
            }
            : null;
        }
      }
    }
  }
  return null;
}


export const applicationToApplicantMiddleName = (application: Application): string | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': {  // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          return applicant.middleName ?? '';
        }
      }
    }
  }
  return null;
}

export const applicationToApplicantDob = (application: Application): Moment | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          return  applicant.dateOfBirth ? moment(applicant.dateOfBirth, 'YYYY-MM-DD') : null;
        }
      }
    }
  }
  return null;
}

export const applicationToApplicantResidentialAddress = (application: Application): Address2ComponentValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          // The guard used to also test HomeAddress, but the legacy projection substituted an
          // all-blank address when the individual had no address row, so it was always truthy and
          // this ran for every applicant. The API shape leaves homeAddress null instead.
          //
          // Every field is coerced to '' for the same reason: that projection did the coercion, so
          // the `?? parseRawAddress(...)` fallbacks these lines used to carry could never fire and
          // are dropped. Letting the API shape's nulls through would switch them on and prefill
          // fragments parsed out of the unformatted address into fields nobody filled in - values a
          // broker would then save. UnitNumber keeps using the parsed address because it never read
          // the row in the first place.
          //
          // StreetName is populated from streetNumber. That is a defect, preserved here rather than
          // fixed so this stays a pure shape change; recorded in docs/az-1475-party-model.md.
          const homeAddress = applicant.homeAddress;
          const parsedAddress = parseRawAddress(homeAddress?.unformattedAddress ?? '');
          const address: Address2ComponentValue = {
            address: homeAddress?.unformattedAddress ?? '',
            UnitNumber: parsedAddress?.unit_number ?? '',
            StreetNumber: homeAddress?.streetNumber ?? '',
            StreetName: homeAddress?.streetNumber ?? '',
            StreetType: homeAddress?.streetType ?? '',
            Suburb: homeAddress?.suburb ?? '',
            State: homeAddress?.state ?? '',
            Postcode: homeAddress?.postcode ?? '',
          };
          return address;
        }
      }
    }
  }
  return null;
};
export const applicationToApplicantTimeInAddress = (application: Application): TimeInAddressValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          const m = applicant.employment?.timeAtAddressMonths ?? 0;
          const t: NonNullable<TimeInAddressValue> = {
            years: parseInt(String(m / 12)),
            months: (m % 12),
            previousAddress: {
              address: applicant.previousAddress?.unformattedAddress ?? '',
              StreetNumber: applicant.previousAddress?.streetNumber ?? '',
              StreetName: applicant.previousAddress?.streetName ?? '',
              StreetType: applicant.previousAddress?.streetType ?? '',
              Suburb: applicant.previousAddress?.suburb ?? '',
              State: applicant.previousAddress?.state ?? '',
              UnitNumber: applicant.previousAddress?.unitNumber ?? '',
              Postcode: applicant.previousAddress?.postcode ?? '',
            },
          }
          return t;
        }
      }
    }
  }
  return null;
};
export const applicationToApplicantPropertyOwnerWithAddress = (application: Application): PropertyOwnerWithAddressValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          const t: PropertyOwnerWithAddressValue = {
            propertyOwner: applicant.property.isOwner,
            // Coerced to '' per field, as in applicationToApplicantResidentialAddress above: the
            // legacy projection did it, the API one keeps the row's nulls. The address itself is
            // absent under both shapes when there is no row - null here, undefined there - so the
            // conditional resolves the same way, as do the two amounts below.
            address: applicant.property.address ? {
              address: applicant.property.address.unformattedAddress ?? '',
              StreetNumber: applicant.property.address.streetNumber ?? '',
              StreetName: applicant.property.address.streetName ?? '',
              StreetType: applicant.property.address.streetType ?? '',
              Suburb: applicant.property.address.suburb ?? '',
              State: applicant.property.address.state ?? '',
              UnitNumber: applicant.property.address.unitNumber ?? '',
              Postcode: applicant.property.address.postcode ?? '',
            } : undefined,
            propertyValue: applicant.property.value ? (applicant.property.value) : undefined,
            mortgageValue: applicant.property.mortgageBalance ? (applicant.property.mortgageBalance): undefined,
          }
          return t;
        }
      }
    }
  }
  return null;
};
export const applicationToApplicantEmail = (application: Application): string | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          return applicant.email ?? '';
        }
      }
    }
  }
  return null;
};
export const applicationToApplicantMobile = (application: Application): string | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          return applicant.mobileNumber ?? '';
        }
      }
    }
  }
  return null;
};
export const applicationToApplicantMaritalStatus = (application: Application): MaritialStatusSelectionValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          const m = applicant.employment?.maritalStatus ?? ''
          const op = MaritialStatusOptions.find(opt => _.toLower(opt.name) === _.toLower(m));
          return op ? op : null;
        }
      }
    }
  }
  return null;
};
export const applicationToApplicantNumberOfDependeants = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          // The cast keeps undefined where the legacy projection put undefined for an unanswered
          // field; the API shape uses null. Same as the employment reads below.
          return (applicant.employment?.numberOfDependants ?? undefined) as number;
        }
      }
    }
  }
  return null;
};
export const applicationToApplicantEmploymentStatus = (application: Application): EmploymentStatusSelectionValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          const op = EmploymentStatusOptions.find(opt => _.toLower(opt.name) === _.toLower(applicant.employment?.employmentStatus ?? ''));
          return op ? op : null;
        }
      }
    }
  }
  return null;
};
export const applicationToApplicantRegularIncome = (application: Application): IncomeSelectionValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          const incomePeriod = incomePeriodOptions.find(opt => _.toLower(opt.type) === _.toLower(applicant.employment?.incomeFrequency ?? ''));
          const income = (applicant.employment?.income ?? undefined) as number;
          return incomePeriod ? {
            income, period: incomePeriod
          } : null;
        }
      }
    }
  }
  return null;
};
export const applicationToApplicantEmployer = (application: Application): EmployerValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          const employer = (applicant.employment?.employer ?? undefined) as string;
          const emplyerContact = (applicant.employment?.employerContact ?? undefined) as string;
          const timeAtEmployment = applicant.employment?.timeAtCurrentEmploymentMonths ?? 0;
          const prevEmployer = (applicant.employment?.previousEmployer ?? undefined) as string;
          const prevEmployerContact = (applicant.employment?.previousEmployerContact ?? undefined) as string;

          return {
            currentEmployer: employer,
            currentEmployerContact: emplyerContact,
            yearsAtCurrentEmployer: parseInt(String(timeAtEmployment / 12)),
            monthsAtCurrentEmployer: (timeAtEmployment % 12),
            previousEmployer: prevEmployer,
            previousEmployerContact: prevEmployerContact,
          };
        }
      }
    }
  }
  return null;
};

export const applicationToApplicantGuarantor = (application: Application): boolean | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer': { // only applicable to consumer finance
        const applicant = applicantOf(application.parties);
        if (applicant) {
          return applicant.isGuarantor;
        }
      }
    }
  }
  return null;
};

export const applicationToDocFee = (application: Application): number | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':   // only applicable to consumer finance
      case 'BusinessLoans':
      case 'CorporateLoans':
      case 'BusinessOverdraft':
        return application.PricingDetails.DocFee;
    }
  }
  return null;
}

export const applicationToInterestRate = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer':   // only applicable to consumer finance
        return String(application.PricingDetails.Rate);
    }
  }
  return null;
}

export const applicationToMargin = (application: Application): number | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'BusinessOverdraft':
      case 'CorporateLoans':
        return application.PricingDetails.Margin;
    }
  }
  return null;
}

export const applicationToSpouseTitle = (application: Application): TitleSelectionValue => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          const t = TitleOptions.find(
            opt => _.toLower(opt.type.toString()) === _.toLower(spouse.title?.toString())
          );
          return t ? t : null;
        }
    }
  }
  return null;
}
export const applicationToSpouseFirstName = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          // No `?? ''` needed, unlike the applicant readers: this already collapses the legacy
          // projection's '' and the API shape's null to the same null.
          const t = spouse.givenName;
          return t ? t : null;
        }
    }
  }
  return null;
}
export const applicationToSpouseLastName = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          const t = spouse.surname;
          return t ? t : null;
        }
    }
  }
  return null;
}
export const applicationToSpouseDob = (application: Application): Moment | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          return spouse.dateOfBirth ? moment(spouse.dateOfBirth, 'YYYY-MM-DD') : null;
        }
    }
  }
  return null;
}
export const applicationToSpouseGender = (application: Application): GenderValue => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          return _.toLower(spouse.gender ?? '') === 'm' ? 'Male' : 'Female';
        }
    }
  }
  return null;
}
export const applicationToSpouseEmail = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          // Returned raw, so unlike the two name readers above this does need the legacy
          // projection's '' coercion to keep handing the form control what it always did.
          return spouse.email ?? '';
        }
    }
  }
  return null;
}
export const applicationToSpouseMobile = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          return spouse.mobileNumber ?? '';
        }
    }
  }
  return null;
}
export const applicationToSpouseEmploymentStatus = (application: Application): EmploymentStatusSelectionValue => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          const op = EmploymentStatusOptions.find(opt => _.toLower(opt.name) === _.toLower(spouse.employment?.employmentStatus ?? ''));
          return op ? op : null;
        }
    }
  }
  return null;
}
export const applicationToSpouseIncome = (application: Application): IncomeSelectionValue => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          const incomePeriod = incomePeriodOptions.find(opt => _.toLower(opt.type) === _.toLower(spouse.employment?.incomeFrequency ?? ''));
          // The cast keeps undefined where the legacy projection put undefined for an unanswered
          // field; the API shape uses null. Same as the two employer readers below.
          const income = (spouse.employment?.income ?? undefined) as number;
          return incomePeriod ? {
            income, period: incomePeriod
          } : null;
        }
    }
  }
  return null;
}
export const applicationToSpouseEmployerName = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          return (spouse.employment?.employer ?? undefined) as string;
        }
    }
  }
  return null;
}
export const applicationToSpouseEmployerContact = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          return (spouse.employment?.employerContact ?? undefined) as string;
        }
    }
  }
  return null;
}
export const applicationToSpouseGuarantor = (application: Application): boolean => {
  if (application) {
    switch (application.ApplicationType) {
      case 'Consumer':
        const spouse = spouseOf(application.parties);
        if (spouse) {
          return spouse.isGuarantor;
        }
    }
  }
  return false;
}
export const applicationToApplicantHomeLoansAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.HomeLoans ?? null;
    }
  }
  return null;
}
export const applicationToApplicantElectricityAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.Electricity ?? null;
    }
  }
  return null;
};
export const applicationToApplicantCarLoansAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.CarLoans ?? null;
    }
  }
  return null;
};
export const applicationToApplicantOtherUtilitiesAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.OtherUtilities ?? null;
    }
  }
  return null;
};
export const applicationToApplicantPersonalLoansAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.PersonalLoans ?? null;
    }
  }
  return null;
};
export const applicationToApplicantEducationAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.Education ?? null;
    }
  }
  return null;
};
export const applicationToApplicantTotalCreditCardLimit = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.CreditCardLimit ?? null;
    }
  }
  return null;
};
export const applicationToApplicantGroceriesAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.Groceries ?? null;
    }
  }
  return null;
};
export const applicationToApplicantOtherLoansAmount = (application: Application): number | null  => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.OtherLoans ?? null;
    }
  }
  return null;
};
export const applicationToApplicantInsuranceAmount = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.Insurance ?? null;
    }
  }
  return null;
};

export const applicationToApplicantShareOfMonthlyLivingExpanses = (application: Application): number | null => {
  if (application) {
    switch(application.ApplicationType) {
      case 'Consumer':
        return application?.Expense?.ShareofExpense ?? null;
    }
  }
  return null;
}

export const applicationToPolicies = (application: Application): PolicyValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'InsurancePremium': {
        if (application.Policies) {
          const policyValue: NonNullable<PolicyValue> = {
            policies: [],
            total: 0,
            paidByMonthlyInstallment: '10',
            monthlyInstallment: 0,
            applicationFee: 0,
            brokerage: 0,
          };
          (application?.Policies ?? []).forEach(p => {
            const coverType = CoverTypeOptions.find(opt => _.toLower(opt.ProductName) === _.toLower(p.typeOfCover));
            const policy: Policy = {
              coverType: coverType ? coverType : null,
              policyNumber: p.policyNumber,
              expiryDate: p.expiryDate ? moment(p.expiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD'], true) : moment(),
              inceptionDate: p.inceptionDate ? moment(p.inceptionDate, ['DD/MM/YYYY', 'YYYY-MM-DD'], true) : moment(),
              invoiceNumber: p.invoiceNumber,
              premiumAmount: Number(p.premiumAmount),
              insurer: p.insurer,
            }
            policyValue.policies.push(policy);
          });
          return policyValue;
        }
      }
    }
  }
  return null;
}


export const applicationToAuthorisedSignatories = (application: Application): AuthorisedSignatoryValue => {
  if (application) {
    switch(application.ApplicationType) {
      case 'InsurancePremium': {
        const as: NonNullable<AuthorisedSignatoryValue> = [];
        if (application.AuthorisedSignatory && application.AuthorisedSignatory.length) {
          application.AuthorisedSignatory.forEach(a => {
            const title = TitleOptions.find(opt => _.toLower(opt.type) === _.toLower(a.Title));
            const role =  authorisedSignatoryRoleOptions.find(opt => _.toLower(opt.name) === _.toLower(a.Role));
            const aus: NonNullable<AuthorisedSignatoryValue>[number] = {
              title: title ?? null,
              firstName: a.GivenName ?? '',
              lastName: a.SurName ?? '',
              email: a.Email ?? '',
              mobile: a.MobileNumber ?? '',
              middleName: a.MiddleName ?? '',
              role: role ?? null,
            }
            as.push(aus);
          });
        }
        return as;
      }
    }
  }
  return null;
}


export const applicationToApplicationNotes = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'AssetFinance':
      case 'BusinessLoans':
      case 'BusinessOverdraft':
      case 'InsurancePremium':
      case 'Commercial':
      case 'TradeFinance':
      case 'CorporateLoans':
      case 'Consumer': {
        return application.ApplicationNotes ?? null;
      }
    }
  }
  return null;
}

export const applicationToLimitRequest = (application: Application): number | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'TradeFinance':
      case 'CorporateLoans':
        return application.PricingDetails.LimitRequest;
    }
  }
  return null;
}

export const applicationToWhatBusinessSell = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'TradeFinance':
      case 'CorporateLoans':
        return application.AppInfo.BusinessSell;
    }
  }
  return null;
};
export const applicationToWhatBusinessBuy = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'TradeFinance':
      case 'CorporateLoans':
        return application.AppInfo.BusinessDescription;
    }
  }
  return null;
};
export const applicationToWhatBussinessSellTo = (application: Application): string | null => {
  if (application) {
    switch (application.ApplicationType) {
      case 'TradeFinance':
      case 'CorporateLoans':
        return application.AppInfo.BusinessSellTerms;
    }
  }
  return null;
};


/**
 * The address parts these helpers need, named as the API shape names them. The legacy adapters
 * below rename into this; nothing else about the three helpers differs between the two shapes.
 */
type ResidentialAddressParts = {
  unformattedAddress?: string | null;
  streetNumber?: string | null;
  streetName?: string | null;
  streetType?: string | null;
  suburb?: string | null;
  state?: string | null;
  postcode?: string | null;
};

export const titleSelectionOf = (title: string | null | undefined): TitleSelectionValue =>
  TitleOptions.find(opt => _.toLower(opt.type.toString()) === _.toLower(title?.toString())) ?? null;

export const dobMomentOf = (dob: string | null | undefined): Moment | null => {
  if (!dob) return null;
  const parsed = moment(dob, moment.ISO_8601, true);
  return parsed.isValid() ? parsed : null;
}

export const residentialAddressOf = (address: ResidentialAddressParts | null | undefined): Address2ComponentValue => {
  if (!address) return null;
  // The unit number comes from the parse even when the address has a stored one, unlike every other
  // part here. Pre-existing (AZ-1475 preserved it); it drops a stored unit number the parse misses.
  const parsedAddress = parseRawAddress(address.unformattedAddress ?? '');
  return {
    address: address.unformattedAddress ?? '',
    UnitNumber: parsedAddress?.unit_number ?? '',
    StreetNumber: address.streetNumber ? address.streetNumber : (parsedAddress?.street_number ?? ''),
    StreetName: address.streetName ? address.streetName : (parsedAddress?.street_name ?? ''),
    StreetType: address.streetType ? address.streetType : (parsedAddress?.street_type ?? ''),
    Suburb: address.suburb ? address.suburb : (parsedAddress?.locality ?? ''),
    State: address.state ? address.state : (parsedAddress?.region ?? ''),
    Postcode: address.postcode ? address.postcode : (parsedAddress?.postal_code ?? ''),
  };
}

const residentialAddressPartsFromLegacy = (address: Address | null | undefined): ResidentialAddressParts | null =>
  address
    ? {
        unformattedAddress: address.UnformattedAddress,
        streetNumber: address.StreetNumber,
        streetName: address.StreetName,
        streetType: address.StreetType,
        suburb: address.Suburb,
        state: address.State,
        postcode: address.Postcode,
      }
    : null;

export const individualTitle = (individual: Individual): TitleSelectionValue =>
  individual ? titleSelectionOf(individual.Title) : null;

export const individualDob = (individual: Individual): Moment | null => dobMomentOf(individual?.DoB);

export const individualResidentialAddress = (individual: Individual): Address2ComponentValue =>
  residentialAddressOf(residentialAddressPartsFromLegacy(individual?.HomeAddress));

export const apiIndividualTitle = (individual: Pick<ApplicationIndividual, 'title'>): TitleSelectionValue =>
  titleSelectionOf(individual?.title);

export const apiIndividualDob = (individual: Pick<ApplicationIndividual, 'dateOfBirth'>): Moment | null =>
  dobMomentOf(individual?.dateOfBirth);

export const apiIndividualResidentialAddress = (individual: Pick<ApplicationIndividual, 'homeAddress'>): Address2ComponentValue =>
  residentialAddressOf(individual?.homeAddress);

export const applicantsToPrimaryContact = (applicants: ApplicationApplicant): ContactValue[] => {
  const contacts: ContactValue[] = [];
  if (applicants) {
    if (Array.isArray(applicants)) {
      for (const applicant of applicants) {
        const c = applicantToPrimaryContact(applicant);
        if (c) {
          contacts.push(c);
        }
      }
    } else {
      const applicant = applicants;
      const c = applicantToPrimaryContact(applicant);
      if (c) {
        contacts.push(c);
      }
    }
  }
  return contacts;
}

export const applicantToPrimaryContact = (applicant: IndividualTrustee | EntityTrustee | IndividualMember | EntityMember | IndividualPartner | EntityPartner | SoleTraderValue | DirectorValueWithPropertyOwnerAddress | DirectorValueWithoutPropertyOwnerAddress): ContactValue | null  => {
  if (applicant) {
    switch(applicant.kind) {
      case 'Member': {
        switch(applicant.type) {
          case 'Individual':
            const c: ContactValue = {
              isManual: false,
              email: applicant.email,
              mobileNumber: applicant.mobileNumber,
              firstName: applicant.firstName,
              lastName: applicant.lastName,
              title: applicant.title,
              telephone: applicant.mobileNumber,
              areaCode: applicant.mobileNumber.substr(0, 2) ?? '',
            }
            return c;
        }
        break;
      }
      case 'Director': {
        switch(applicant.type) {
          case 'WithoutPropertyAddress':
          case 'WithPropertyAddress': {
            const c: ContactValue = {
              isManual: false,
              email: applicant.email,
              mobileNumber: applicant.mobileNumber,
              firstName: applicant.firstName,
              lastName: applicant.lastName,
              title: applicant.title,
              telephone: applicant.mobileNumber,
              areaCode: applicant.mobileNumber.substr(0, 2) ?? '',
            }
            return c;
          }
        }
        break;
      }
      case 'Partner': {
        switch(applicant.type) {
          case 'Individual': {
            const c: ContactValue = {
              isManual: false,
              email: applicant.email,
              mobileNumber: applicant.mobileNumber,
              firstName: applicant.firstName,
              lastName: applicant.lastName,
              title: applicant.title,
              telephone: applicant.mobileNumber,
              areaCode: applicant.mobileNumber.substr(0, 2) ?? '',
            }
            return c;
          }
        }
        break;
      }
      case 'SoleTrader': {
        const c: ContactValue = {
          isManual: false,
          email: applicant.email,
          mobileNumber: applicant.mobile,
          firstName: applicant.firstName,
          lastName: applicant.lastName,
          title: applicant.title,
          telephone: applicant.mobile,
          areaCode: applicant.mobile.substr(0, 2) ?? '',
        }
        return c;
      }
      case 'Trustee': {
        switch(applicant.type) {
          case 'Individual': {
            const c: ContactValue = {
              isManual: false,
              email: applicant.email,
              mobileNumber: applicant.mobileNumber,
              firstName: applicant.firstName,
              lastName: applicant.lastName,
              title: applicant.title,
              telephone: applicant.mobileNumber,
              areaCode: applicant.mobileNumber.substr(0, 2) ?? '',
            }
            return c;
          }
        }
        break;
      }
    }
  }
  return null;
}

export const isTrustApplication = (application: Application) => {
  return primaryEntityOf(application.parties)?.entityType === 'TRST';
}

export const isPartnershipApplication = (application: Application) => {
  return primaryEntityOf(application.parties)?.entityType === 'PTNR';
}

export const applicationDefaultDocuments = (application: Application, includeOptional = false): DocumentTag[] => {
  const individuals = application.parties?.individuals ?? [];
  // Through the legacy-role shim, not isGuarantor, matching document-details-sub-table: `Role`
  // collapsed each individual's flags to one string by precedence, so a director who also guarantees
  // read back as 'Director' and never appeared in this list. Reading the flag instead would ask for
  // more documents than today - the same change already made server-side for the approval notice, and
  // the two now disagree - but it is a behaviour change this migration is not making.
  const guarantorNames = individuals
    .filter(individual => individualRoleType(individual) === 'Guarantor')
    .map(individual => `${individual.givenName ?? ''} ${individual.surname ?? ''}`);
  const applicant = applicantOf(application.parties);
  // The literal is deliberate, as in the sub-table: the legacy expression concatenated two undefined
  // values when a consumer application had no Applicant individual, naming the document set
  // "undefined undefined".
  const applicantName = applicant
    ? `${applicant.givenName ?? ''} ${applicant.surname ?? ''}`
    : 'undefined undefined';
  return defaultDocuments(
    application.ApplicationType,
    guarantorNames,
    application.ApplicationType === "Consumer" ? applicantName : (primaryEntityOf(application.parties)?.legalName ?? ""),
    "",
    "",
    (application.PricingDetails as any).LoanAmount,
    (application.PricingDetails as any).Deposit,
    (application.PricingDetails as any).PrivateSale === "Yes",
    isTrustApplication(application),
    isPartnershipApplication(application),
    includeOptional
  )
}

export const LESS_THAN_SUBMITTED_TO_CREDIT_STAGE = ['lead', 'draft']; //Unsure if draft is correct
export const CREDIT_STAGES = ['submitted to credit', 'waiting for bank statements', 'more information', 'credit approved'];
export const GREATER_THAN_CREDIT_APPROVED_STAGE = ['documentation','docs out', 'settlement pending', 'qa', 'settlement'];
export const GREATER_THAN_CLOSED_STAGE = ['closed won', 'closed lost'];
// Simplified routing: Prior to Docs Out -> Finance Sales, From Docs Out onwards -> Settlements
export const PRE_DOCS_OUT_STAGES = ['lead', 'draft', 'submitted to credit', 'waiting for bank statements', 'more information', 'credit approved', 'documentation'];
export const DOCS_OUT_AND_BEYOND_STAGES = ['docs out', 'settlement pending', 'qa', 'settlement', 'closed won', 'closed lost'];

//////////////////// Documentworklist
export const filterDocumentworklist = (filter: DocumentWorklistCategory, worklist: DocumentWorklists): DocumentWorklists => {
  switch (filter) {
    case "credit":
      return worklist.filter(w => ["Submitted to Credit", "More Information", "Waiting for Bank Statements"].includes(w.stage));
    case "client-services":
      return worklist.filter(w => ["Credit Approved", "QA", "Settlement", "Closed Won"].includes(w.stage));
    case "settlements":
      return worklist.filter(w => ["Documentation", "Docs Out", "Settlement Pending"].includes(w.stage));
    default:
      return worklist;
  }
}

///////////////////////////////////////////////////////
///// Inteflow
//////////////////////////////////////
const validDateOnly = (value: Moment | null | undefined): string | undefined =>
  value?.isValid() ? value.format('YYYY-MM-DD') : undefined;

/**
 * The legacy address literals the per-kind blocks below still build, in the API shape. Field-for-field
 * with no defaulting, so whatever each block put there - '' from the applicant branches, undefined from
 * the guarantor one - survives, and the rows a save produces are unchanged. The blocks themselves are
 * left alone deliberately: they carry per-kind quirks (a Director's propertyOwner can be a bare boolean)
 * that are not worth re-deriving while flipping the payload shape.
 */
const legacyAddressToApi = (address?: {
  UnformattedAddress?: string;
  UnitNumber?: string;
  StreetNumber?: string;
  StreetName?: string;
  StreetType?: string;
  Suburb?: string;
  State?: string;
  Postcode?: string;
  IsManualInput?: boolean;
}): ApplicationAddressApi | undefined => address ? {
  unformattedAddress: address.UnformattedAddress,
  unitNumber: address.UnitNumber,
  streetNumber: address.StreetNumber,
  streetName: address.StreetName,
  streetType: address.StreetType,
  suburb: address.Suburb,
  state: address.State,
  postcode: address.Postcode,
  isManualInput: address.IsManualInput,
} : undefined;

/** Applicant `kind` as role flags. 'Member' has always been stored as a trustee. */
const applicantRoleFlags = (kind: string): ApplicationIndividualRoleFlags => ({
  isDirector: kind === 'Director',
  isPartner: kind === 'Partner',
  isTrustee: kind === 'Trustee' || kind === 'Member',
  isSoleTrader: kind === 'SoleTrader',
  isShareholder: false,
  isSpouse: false,
});

export const fromApplicantToInteflowIndividualsData = (applicants: ApplicationApplicant): ApplicationIndividualWrite[] => {
  const individualApplicants = applicantsThatAreIndividual(applicants);
  const otherIndividuals = [];
  for (const individualApplicant of individualApplicants) {
    let propertyOwner = false;
    let propertyValue = undefined;
    let middleName = undefined;
    let mortgageBalance = undefined;
    let addressOfPropertyOwned = undefined;
    let mobileNumber = undefined;

    switch(individualApplicant.kind) {
      case 'Trustee':
      case 'Partner':
      case 'Member': {
        middleName = individualApplicant.middleName;        mobileNumber = individualApplicant.mobileNumber;
        const p: PropertyOwnerWithAddressValue = individualApplicant.propertyOwner;
        if (p) {
          propertyOwner = p.propertyOwner;
          propertyValue = p.propertyValue;
          mortgageBalance = p.mortgageValue;
          addressOfPropertyOwned = p.address?.address ? {
            UnformattedAddress: p.address.address,
            UnitNumber: p.address?.UnitNumber ?? '',
            StreetNumber: p.address?.StreetNumber ?? '',
            StreetName: p.address?.StreetName ?? '',
            StreetType: p.address?.StreetType ?? '',
            Suburb: p.address?.Suburb ?? '',
            State: p.address?.State ?? '',
            Postcode: p.address?.Postcode ?? '',
          } :  undefined;
        }
        break;
      }
      case 'SoleTrader': {        mobileNumber = individualApplicant.mobile;
        const p = individualApplicant.propertyOwner;
        if (p) {
          propertyOwner = p.propertyOwner;
          propertyValue = p.propertyValue;
          mortgageBalance = p.mortgageValue;
          addressOfPropertyOwned = p.address?.address ? {
            UnformattedAddress: p.address.address,
            UnitNumber: p.address?.UnitNumber ?? '',
            StreetNumber: p.address?.StreetNumber ?? '',
            StreetName: p.address?.StreetName ?? '',
            StreetType: p.address?.StreetType ?? '',
            Suburb: p.address?.Suburb ?? '',
            State: p.address?.State ?? '',
            Postcode: p.address?.Postcode ?? '',
          } : undefined;
        }
        break;
      }
      case 'Director': {
        console.log('*&&&&&&&&&&&&&&&&&&&&&&&&& director', individualApplicant);        mobileNumber = individualApplicant.mobileNumber;
        const p = individualApplicant.propertyOwner;
        if (p && (typeof (p as any)['propertyOwner']) === 'boolean') {
          propertyOwner = (p as Exclude<PropertyOwnerWithAddressValue, null>).propertyOwner;
          propertyValue = (p as Exclude<PropertyOwnerWithAddressValue, null>).propertyValue;
          mortgageBalance = (p as Exclude<PropertyOwnerWithAddressValue, null>).mortgageValue;
          addressOfPropertyOwned = (p as Exclude<PropertyOwnerWithAddressValue, null>).address?.address ?
            {
              UnformattedAddress: (p as Exclude<PropertyOwnerWithAddressValue, null>).address!.address,
              UnitNumber: (p as NotNullable<PropertyOwnerWithAddressValue>).address?.UnitNumber ?? '',
              StreetNumber: (p as NotNullable<PropertyOwnerWithAddressValue>).address?.StreetNumber ?? '',
              StreetName: (p as NotNullable<PropertyOwnerWithAddressValue>).address?.StreetName ?? '',
              StreetType: (p as NotNullable<PropertyOwnerWithAddressValue>).address?.StreetType ?? '',
              Suburb: (p as NotNullable<PropertyOwnerWithAddressValue>).address?.Suburb ?? '',
              State: (p as NotNullable<PropertyOwnerWithAddressValue>).address?.State ?? '',
              Postcode: (p as NotNullable<PropertyOwnerWithAddressValue>).address?.Postcode ?? '',
            } :  undefined;
        } else {
          propertyOwner = (p as boolean);
        }
        break;
      }
    }
    const individual: ApplicationIndividualWrite = {
      // A person prefilled from a reopened draft keeps their saved row's guid, so every later save
      // resolves to that row even after Individual Details has corrected the name or date of birth
      // the prefill was taken with. A person typed in gets one minted here rather than left to the
      // server: tagIndividualIdDocumentFiles stamps it into the uploaded driver's licence blob
      // metadata as individualid, and saveApplicationParties adopts it as the new row's legacyId.
      guid: individualApplicant.guid ?? v4(),
      title: individualApplicant.title?.type ?? undefined,
      givenName: individualApplicant.firstName,
      middleName: middleName ?? '',
      surname: individualApplicant.lastName,
      dateOfBirth: validDateOnly(individualApplicant.dob),
      gender: toInteflowGender(individualApplicant.gender),
      property: {
        isOwner: propertyOwner,
        value: propertyValue !== null ? propertyValue : 0,
        mortgageBalance: mortgageBalance !== null ? mortgageBalance : 0,
        address: legacyAddressToApi(addressOfPropertyOwned),
      },
      isGuarantor: individualApplicant.guarantor ?? false,
      email: individualApplicant.email,
      mobileNumber:  mobileNumber,
      hasAlias: individualApplicant.hasAlias ?? false,
      aliasNames: individualApplicant.hasAlias ? (individualApplicant.aliasNames ?? undefined) : undefined,
      countryOfCitizenship: individualApplicant.countryOfCitizenship?.name ?? undefined,
      identification: individualApplicant.identification ? {
        type: individualApplicant.identification.idType ?? undefined,
        number: individualApplicant.identification.idNumber ?? undefined,
      } : undefined,
      isDeleted: false,
      homeAddress: legacyAddressToApi((individualApplicant.residentialAddress?.address) ? ({
        UnformattedAddress: individualApplicant.residentialAddress?.address,
        UnitNumber: (individualApplicant).residentialAddress?.UnitNumber ?? '',
        StreetNumber: (individualApplicant).residentialAddress?.StreetNumber ?? '',
        StreetName: (individualApplicant).residentialAddress?.StreetName ?? '',
        StreetType: (individualApplicant).residentialAddress?.StreetType ?? '',
        Suburb: (individualApplicant).residentialAddress?.Suburb ?? '',
        State: (individualApplicant).residentialAddress?.State ?? '',
        Postcode: (individualApplicant).residentialAddress?.Postcode ?? '',
      }) : undefined),
      role: applicantRoleFlags(individualApplicant.kind),
      // Applicants sign. Whether they also guarantee is what decides Signer against GuarantorSigner,
      // which apiSignerRoleFromRoleFlags derives from these two rather than from a string.
      isSigner: true,
      // The entity-less individual borrower, ie. the legacy Role 'Applicant'. Never one of these:
      // every applicant here holds a role against a company.
      isApplicant: false,
      // The page decides this, by matching against the nominated primary contact.
      isPrimaryContact: false,
    }
    otherIndividuals.push(individual);
  }

  return otherIndividuals;
}


export const fromGuarantorToInteflowIndividuals = (guarantors: GuarantorValue): ApplicationIndividualWrite[] => {
  const otherIndividuals = [];
  if (guarantors) {
    const individualGuarantors = guarantorsThatAreIndividual(guarantors);
    for (const individualGuarantor of individualGuarantors) {
      let propertyOwner = false;
      let propertyValue = undefined;
      let middleName = undefined;
      let mortgageBalance = undefined;
      let addressOfPropertyOwned = undefined;
      const p = individualGuarantor.propertyOwner;
      if (p && ((p as any)['propertyOwner'])) {
        propertyOwner = (p as Exclude<PropertyOwnerWithAddressValue, null>).propertyOwner;
        propertyValue = (p as Exclude<PropertyOwnerWithAddressValue, null>).propertyValue;
        mortgageBalance = (p as Exclude<PropertyOwnerWithAddressValue, null>).mortgageValue;
        addressOfPropertyOwned = (p as Exclude<PropertyOwnerWithAddressValue, null>).address?.address ?
          {
            UnformattedAddress: (p as Exclude<PropertyOwnerWithAddressValue, null>).address!.address,
            UnitNumber: (p as NotNullable<PropertyOwnerWithAddressValue>).address!.UnitNumber,
            StreetNumber: (p as NotNullable<PropertyOwnerWithAddressValue>).address!.StreetNumber,
            StreetName: (p as NotNullable<PropertyOwnerWithAddressValue>).address!.StreetName,
            StreetType: (p as NotNullable<PropertyOwnerWithAddressValue>).address!.StreetType,
            Suburb: (p as NotNullable<PropertyOwnerWithAddressValue>).address!.Suburb,
            State: (p as NotNullable<PropertyOwnerWithAddressValue>).address!.State,
            Postcode: (p as NotNullable<PropertyOwnerWithAddressValue>).address!.Postcode,
            IsManualInput: false,
          } : undefined;
      }
      const individual: ApplicationIndividualWrite = {
        // See the applicant mapper: load-bearing for ID document tagging, not legacy habit.
        guid: v4(),
        title: individualGuarantor.title?.type ?? undefined,
        givenName: individualGuarantor.firstName ?? undefined,
        middleName: individualGuarantor.middleName ?? '',
        surname: individualGuarantor.lastName ?? undefined,
        dateOfBirth: validDateOnly(individualGuarantor.dob),
        gender: toInteflowGender(individualGuarantor.gender),
        property: {
          isOwner: propertyOwner,
          value: propertyValue,
          mortgageBalance: mortgageBalance,
          address: legacyAddressToApi(addressOfPropertyOwned),
        },
        isGuarantor: true,
        email: individualGuarantor.email ?? undefined,
        mobileNumber:  individualGuarantor.mobileNumber ?? undefined,
        hasAlias: individualGuarantor.hasAlias ?? false,
        aliasNames: individualGuarantor.hasAlias ? (individualGuarantor.aliasNames ?? undefined) : undefined,
        countryOfCitizenship: individualGuarantor.countryOfCitizenship?.name ?? undefined,
        identification: individualGuarantor.identification ? {
          type: individualGuarantor.identification.idType ?? undefined,
          number: individualGuarantor.identification.idNumber ?? undefined,
        } : undefined,
        isDeleted: false,
        homeAddress: legacyAddressToApi(individualGuarantor.residentialAddress?.address ? {
          UnformattedAddress: individualGuarantor.residentialAddress?.address,
          UnitNumber: individualGuarantor.residentialAddress?.UnitNumber,
          StreetNumber: individualGuarantor.residentialAddress?.StreetNumber,
          StreetName: individualGuarantor.residentialAddress?.StreetName,
          StreetType: individualGuarantor.residentialAddress?.StreetType,
          Suburb: individualGuarantor.residentialAddress?.Suburb,
          State: individualGuarantor.residentialAddress?.State,
          Postcode: individualGuarantor.residentialAddress?.Postcode,
          IsManualInput: false,
        } : undefined),
        // A personal guarantor holds no business role, which is what the legacy pair
        // Role: 'Guarantor' / SignerRole: 'Guarantor' said - and it says they do not sign.
        role: null,
        isSigner: false,
        isApplicant: false,
        isPrimaryContact: false,
      }
      otherIndividuals.push(individual);
    }
  }
  return otherIndividuals;
}


export const fromApplicantToInteflowCommercialEntities = (applicants: ApplicationApplicant): ApplicationCommercialEntityWrite[] => {
  const entityApplicants = applicantsThatAreEntity(applicants);
  const otherCommercialEntity: ApplicationCommercialEntityWrite[] = [];
  for (const entityApplicant of entityApplicants) {
    // No tradingName: this form only captures the entity's name, so sending the legal name as a
    // trading name would invent one. Omitting it leaves whatever is stored untouched - which is why
    // the write conversion has to preserve absence here rather than default to a blank.
    const commercialEntity: ApplicationCommercialEntityWrite = {
      legalName: entityApplicant.organisation?.name ?? undefined,
      abn: entityApplicant.abn ?? undefined,
      acn: _.isEmpty(entityApplicant.acn) ? undefined : entityApplicant.acn,
      // Replaces `Type: entityApplicant.kind`. These applicants are never the borrower and never the
      // guarantor; the relationship to the primary entity is the whole of what their Type expressed.
      // A 'Member' entity becomes a trustee, matching what the individual mapper has always done with
      // that kind - the entity path sending it through raw was the inconsistent one.
      isPrimary: false,
      isGuarantor: false,
      relationships: [{
        isTrustee: entityApplicant.kind === 'Trustee' || entityApplicant.kind === 'Member',
        isPartner: entityApplicant.kind === 'Partner',
      }],
      entityType: entityApplicant.organisationType ? toInteflowEntityTypes(entityApplicant.organisationType.type) : undefined,
      manualEntry: entityApplicant.manualEntry ?? false,
    }

    otherCommercialEntity.push(commercialEntity);
  }
  return otherCommercialEntity;
}

export const fromGuarantorToInteflowCommercialEnttities = (guarantors: GuarantorValue): ApplicationCommercialEntityWrite[] => {
  const otherCommercialEntity: ApplicationCommercialEntityWrite[] = [];
  if (guarantors) {
    const entityGuarantors = guarantorsThatAreEntity(guarantors);
    for (const entityGuarantor of entityGuarantors) {
      const commercialEntity: ApplicationCommercialEntityWrite = {
        legalName: entityGuarantor.organisation?.name ?? undefined,
        abn: entityGuarantor.abn ?? undefined,
        acn: entityGuarantor.acn ?? undefined,
        // No relationship to the primary entity and not primary itself, which is what makes this a
        // guarantor entity once the Type string is derived rather than stated.
        isPrimary: false,
        isGuarantor: true,
        relationships: [],
        // Unlike the applicant form above, this one does send the name as the trading name too.
        tradingName: entityGuarantor?.organisation?.name ?? undefined,
        entityType: entityGuarantor.organisationType ? toInteflowEntityTypes(entityGuarantor.organisationType.type) : undefined,
        manualEntry: false,
      }
      otherCommercialEntity.push(commercialEntity);
    }
  }
  return otherCommercialEntity;
}

export const fromReferenceToInteflowReferences = (refValue: ReferenceValue): Exclude<SaveApplicationData['Reference'], undefined> => {
  const references = [];
  if (refValue) {
    for (const ref of refValue) {
      const r = {
        CompanyName: ref.company ?? undefined,
        Telephone: ref.phoneNumber,
        ContactPerson: ref.contactPerson,
        Type: ref.referenceType?.name ?? undefined,
      };
      references.push(r);
    }
  }
  return references;
}

export const fromContactToInteflowContacts = (contact: ContactValue | null): SaveApplicationData['Contacts'] => {
  let telephone = contact?.telephone;
  let areaCode = contact?.areaCode;
  telephone = telephone ?  _.replace(telephone, /\s/g, '') : telephone;
  if (telephone && telephone.length >= 10) {
    telephone = telephone.substring(2).trim();
    areaCode = telephone.substring(0, 2).trim();
  }
  const apiBodyContact = {
    Title: contact?.title?.type ?? undefined,
    GivenName: contact?.firstName ?? undefined,
    SurName: contact?.lastName ?? undefined,
    Email: contact?.email ?? undefined,
    MiddleName: undefined,
    // Telephone: (telephone && telephone != '' ? telephone : undefined),
    Mobile: contact?.mobileNumber ?? undefined,
    AreaCode: (areaCode && areaCode != '' ? areaCode : undefined),
    // isManual: contact?.isManual ?? undefined
    Contact:'primaryContact'
  }
  return apiBodyContact;
}

// Merges the latest SAVED individuals (ApplicationIndividual rows, as edited on the "Individual
// Details" step) into the wizard-derived legacy Individuals payload. The wizard pages rebuild
// Individuals from their step form values (guarantors etc.) on every save, so without this the
// parties full-sync would overwrite edits already persisted through /save-application-parties with
// stale step values. Entries are matched by name + date of birth (payload ids are regenerated on
// every mapToInteflowData call, so they never match); unmatched payload entries (e.g. a guarantor
// added after the review step without revisiting it) pass through unchanged, and saved rows not
// described by the payload (KYB-sourced individuals) are deliberately NOT added - the backend
// full-sync does not own those rows. Contact is overlaid from the saved row too: the dedicated
// primary-contact step was retired (the caller's own GivenName/SurName/Email match against the
// earlier steps' form values goes stale the moment those fields are completed/edited here, e.g. a
// guarantor's email, which the guarantor step never collects, wiping isPrimaryContact on the next
// full-sync).
// The "Individual Details" step replaced the dedicated primary-contact step: it flags the chosen
// person on their ApplicationIndividual row, so the wizard derives its Contacts payload and summary
// from that saved row rather than from a form control of its own.
export const savedIndividualsToPrimaryContact = (
  savedIndividuals: ApplicationIndividual[] | undefined,
): ContactValue | null => {
  const primary = (savedIndividuals ?? []).find(individual =>
    !individual.isDeleted && individual.isPrimaryContact);
  return primary ? savedIndividualToContact(primary) : null;
};

const savedIndividualToContact = (individual: ApplicationIndividual): ContactValue => ({
  isManual: false,
  title: TitleSelectionValueOptions.find(option => option.type === individual.title) ?? null,
  firstName: individual.givenName ?? '',
  lastName: individual.surname ?? '',
  mobileNumber: individual.mobileNumber ?? '',
  telephone: individual.mobileNumber ?? '',
  email: individual.email ?? '',
  areaCode: '',
});

// Every individual from the "Individual Details" step, for the wizard's final summary. The
// nominated primary contact is sorted first so it keeps the prominence it had when the summary
// showed it alone.
export const savedIndividualsToContacts = (
  savedIndividuals: ApplicationIndividual[] | undefined,
): SummaryContactValue[] => {
  return (savedIndividuals ?? [])
    .filter(individual => !individual.isDeleted)
    .map(individual => ({
      ...savedIndividualToContact(individual),
      isPrimaryContact: !!individual.isPrimaryContact,
      role: individualRoleType(individual),
      signerRole: individualSignerRole(individual),
    }))
    .sort((a, b) => Number(b.isPrimaryContact) - Number(a.isPrimaryContact));
};

// Corporate parties of the application, for the summary's Entities section. A company has no
// individual to appear under Contacts, so without this the summary would lose it entirely.
// Directors and sole traders are always natural persons and so never appear here.
export const summaryEntityParties = (
  applicants: ApplicationApplicant | undefined,
  guarantors: GuarantorValue | undefined,
): SummaryEntityValue[] => {
  const toEntity = (
    role: string,
    party: EntityTrustee | EntityMember | EntityPartner | EntityGuarantor,
  ): SummaryEntityValue => ({
    role,
    name: party.organisation.name,
    organisationType: party.organisationType.name,
    abn: party.abn,
    acn: party.acn,
  });
  return [
    ...applicantsThatAreEntity(applicants ?? null).map(party => toEntity(party.kind, party)),
    ...guarantorsThatAreEntity(guarantors ?? []).map(party => toEntity('Guarantor', party)),
  ];
};

// Signatories for the submit consent acknowledgement, re-read from the backend rather than taken
// from the "Individual Details" step's control value. That value is only a snapshot from when the
// step was last rendered - the stepper destroys the step it leaves - so it misses anyone a later
// KYB or guarantor edit added, while the backend dispatches a consent form to every non-deleted
// individual saved on the application. Falls back to the snapshot if the read fails, so a
// transient error cannot block submission.
export const consentAcknowledgementIndividuals = (
  getApplicationIndividualsFn: (applicationId: number) => Observable<GetApplicationindividualsPayload>,
  applicationId: number | null,
  savedIndividuals: ApplicationIndividual[] | undefined,
): Observable<ApplicationConfirmationDialogIndividual[]> => {
  const fallback = () => of(apiIndividualsToConfirmationIndividuals(savedIndividuals ?? []));
  if (!applicationId) {
    return fallback();
  }
  return getApplicationIndividualsFn(applicationId).pipe(
    map(payload => apiIndividualsToConfirmationIndividuals(payload.individuals)),
    catchError(fallback),
  );
};

// No longer generic: the extra Contact field the pages used to bolt on is now isPrimaryContact, part
// of the write shape itself. Both sides are the API shape now that the Individual Details step is
// migrated, so this is a read-shape to write-shape merge rather than a translation between
// vocabularies (AZ-1475).
export const mergeSavedIndividualsIntoInteflowIndividuals = (
  payloadIndividuals: ApplicationIndividualWrite[],
  savedIndividuals: ApplicationIndividual[],
): ApplicationIndividualWrite[] => {
  const normaliseDob = (dob?: string | null) => dob ? moment(dob).format('YYYY-MM-DD') : '';
  const active = savedIndividuals.filter(individual => !individual.isDeleted);
  // A saved row is claimed by at most one entry: it hands over its guid below, and two entries
  // carrying the same guid would both resolve to that one row in the full-sync.
  const claimed = new Set<ApplicationIndividual>();
  const entries = payloadIndividuals ?? [];
  const matches: (ApplicationIndividual | undefined)[] = entries.map(() => undefined);
  const claim = (index: number, saved: ApplicationIndividual | undefined) => {
    if (saved && !claimed.has(saved)) {
      matches[index] = saved;
      claimed.add(saved);
    }
  };
  // By guid first, across every entry, so an entry still carrying the identity it was prefilled with
  // cannot lose its own row to another entry's name and date of birth match.
  entries.forEach((entry, index) => {
    if (entry.guid) claim(index, active.find(saved => saved.guid === entry.guid));
  });
  // Then by name and date of birth, under the same rule the server's full-sync applies.
  const openEntries = entries.map((_, index) => index).filter(index => !matches[index]);
  const openSaved = active.filter(saved => !claimed.has(saved));
  const identityOf = (person: ApplicationIndividualWrite | ApplicationIndividual) => ({
    givenName: person.givenName,
    middleName: person.middleName,
    surname: person.surname,
    dateOfBirth: normaliseDob(person.dateOfBirth),
  });
  pairIndividualsByIdentity(openEntries.map(index => identityOf(entries[index])), openSaved.map(identityOf))
    .rowFor.forEach((saved, entry) => claim(openEntries[entry], openSaved[saved]));
  return entries.map((entry, index) => {
    const match = matches[index];
    if (!match) {
      return entry;
    }
    return {
      ...entry,
      // The saved row's identifier, so the full-sync resolves this entry to that row outright instead
      // of falling back to identity or position - the step forms this payload is rebuilt from cannot
      // name the row they describe.
      guid: match.guid ?? entry.guid,
      title: match.title ?? entry.title,
      givenName: match.givenName,
      middleName: match.middleName,
      surname: match.surname,
      dateOfBirth: normaliseDob(match.dateOfBirth),
      email: match.email,
      mobileNumber: match.mobileNumber,
      homeAddress: match.homeAddress ?? entry.homeAddress,
      hasAlias: match.hasAlias,
      aliasNames: match.aliasNames,
      countryOfCitizenship: match.countryOfCitizenship,
      identification: {
        type: match.identification?.type,
        number: match.identification?.number,
      },
      isPrimaryContact: !!match.isPrimaryContact,
      // AZ-1245: Individual Details is the only step that collects these - the earlier steps this
      // payload is otherwise rebuilt from (eg. guarantors) never populate them, so without this
      // overlay a full-sync silently resets Property Owner back to No.
      property: {
        isOwner: match.property?.isOwner ?? null,
        value: match.property?.value,
        mortgageBalance: match.property?.mortgageBalance,
        address: match.property?.address,
      },
      // Same reasoning for the links to other entities: only Individual Details collects them, and
      // the save full-syncs role rows, so a payload without them soft-deletes the stored ones.
      // Every such link, not just the guarantees - this payload is the full sync, and a role it
      // omits is a role deleted, whatever the shape can say about it.
      additionalRoles: individualEntityRoleWrites(match),
    };
  });
};

// ====================================
// === Trade Customer
// ====================================

export const showDueDate = (passDueDate: boolean, nextDueDate?: string): string => {
  if (passDueDate) {
    return 'Now';
  }
  return nextDueDate ? moment(nextDueDate).format('DD MMM Y') : '---';
}

export const showDueAmount = (passDueDate: boolean, balancePayable?: number, nextBalancePayable?: number): string => {
  if (passDueDate && balancePayable) {
    return '$' +(balancePayable).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }
  if (!passDueDate && nextBalancePayable) {
    return '$' +(nextBalancePayable).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }
  return '---';
}


// =========================
// === Digital ID
// =========================
export const isOnSuccessMessageAnError = (msg: OnCompleteMessage): msg is OnCompleteMessageError => {
  return  ((msg as OnCompleteMessageError).error !== undefined);
}

// ==========================
// ====   Accreditation tabs
// ==========================
export const hasMultipleRole = (user: Pick<PortalLoginUser, 'priviledges'>): boolean => {
  let roleCount = 0
  const priviledges = (user?.priviledges ?? []);
  roleCount += (  // all these are counted as 1
      priviledges.includes('admin') ||
      priviledges.includes('analyst') ||
      priviledges.includes('companyadmin') ||
      priviledges.includes('externalbroker') ||
      priviledges.includes('internalbroker') ||
      priviledges.includes('companyoperator') ||
      priviledges.includes('broker')||
      priviledges.includes('credit') ||
      priviledges.includes('operations') ||
      priviledges.includes('operations24') ||
      priviledges.includes('salesBDM') ||
      priviledges.includes('salesAM')
  ) ? 1 : 0;
  roleCount += priviledges.includes('trade') ? 1 : 0;
  roleCount += priviledges.includes('overdraft') ? 1 : 0;
  return (roleCount > 1)
}

export const hasAccessBrokerDashboard = (user: Pick<PortalLoginUser, 'priviledges'>): boolean => {
  const priviledges = (user?.priviledges ?? []);
  return (
    priviledges.includes('admin') ||
    priviledges.includes('analyst') ||
    priviledges.includes('companyadmin') ||
    priviledges.includes('externalbroker') ||
    priviledges.includes('internalbroker') ||
    priviledges.includes('companyoperator') ||
    priviledges.includes('broker') ||
    priviledges.includes('credit') ||
    priviledges.includes('operations') ||
    priviledges.includes('salesBDM') ||
    priviledges.includes('salesAM')
  );
}

export const hasAccessOverdraftDashboard = (user: Pick<PortalLoginUser, 'priviledges'>): boolean => {
  const priviledges = (user?.priviledges ?? []);
  return priviledges.includes('overdraft');
}

export const hasAccessCardOperatorDashboard = (user: Pick<PortalLoginUser, 'priviledges'>): boolean => {
  const priviledges = (user?.priviledges ?? []);
  return priviledges.includes('operations24');
}

// ==========================
// ====   Generate Contract
// ==========================
export const checkContractIndividuals = (application: Application, dialogService?: ApplicationDialogService): boolean => {
  // No soft-delete filter: applicationIndividualsToApi applies it at the projection, which is where
  // the legacy read boundary applied it too, so the `deleted !== true` pass this used to carry is
  // already done.
  const individuals = application.parties?.individuals ?? []
  const indvidualWithNoEmailOrMobile = individuals.filter(ind => _.isEmpty(ind.email) || _.isEmpty(ind.mobileNumber))
  if (indvidualWithNoEmailOrMobile.length) {
    let names: string[] = []
    indvidualWithNoEmailOrMobile.map(ind => {
      names.push(`${ind.givenName ?? ''} ${ind.surname ?? ''}`)
    })
    if(dialogService) {
      dialogService.openAlertDialog({
        message: `Missing contact info`,
        subMessage: `${names.join(', ')} has missing Email or Mobile Number`,
      });
    }
    return false;
  } else {
    const indWithSameEmailorPhone = [...new Set(individualHavingSameEmailOrPhone(individuals))]
    if (indWithSameEmailorPhone.length) {
      if (dialogService) {
        dialogService.openAlertDialog({
          message: `Duplicate Email or Mobile`,
          subMessage: `${indWithSameEmailorPhone.join(', ')} has duplicate Email or Mobile Number`,
        });
      }
      return false;
    }
    return true;
  }
}

export const individualHavingSameEmailOrPhone = (individuals: ApplicationIndividual[]) => {
  const contactMap = new Map();
  individuals.forEach((individual) => {
    const email = individual.email;
    const phone = individual.mobileNumber;
    const name = `${individual.givenName ?? ''} ${individual.surname ?? ''}`;
    if (email && name) {
      const names = contactMap.get(email) || [];
      contactMap.set(email, [...names, name]);
    }
    if (phone && name) {
      const names = contactMap.get(phone) || [];
      contactMap.set(phone, [...names, name]);
    }
  });
  const result: any = [];
  contactMap.forEach((names, contact) => {
    if (names.length > 1) {
      result.push(...names);
    }
  });
  return result;
}

export const displayGenerateContractButton = (user: Pick<PortalLoginUser, 'priviledges'> | null, productionMode: boolean): boolean => {
    return isInternalUserOrBroker(user);
}


// ==========================
// ====   Individual and Entity Info
// ==========================
export const getEntityType = (result: BusinessNumberSearchResult[number]): EntityTypeValue => {
  if (result) {
    if (result['organisation-number']) {
      return { name: 'Company', type: 'company' } //eg 89643308267
    }
    if (result['australian-business-register-report'] && result['australian-business-register-report'].type == 'result') {
      const report = result['australian-business-register-report']
      if (report.EntityTypeInd && report.EntityTypeInd == 'IND') {
        return { name: 'SoleTrader', type: 'sole-trader' } //eg 94391035453
      }
      if (report.EntityTypeText.toLowerCase().includes('trust')) {
        return { name: 'Trust', type: 'trust' } //eg 43423767626
      }
      if (report.EntityTypeText.toLowerCase().includes('partnership')) {
        return { name: 'Partnership', type: 'partnership' } //eg 45663186604
      }
    }
  }
  return { name: 'Other', type: 'other' }
}

/**
 * Inform <code>store</code> when count has reduced to zero. Count can be reduced by <code>countDown()</code> function in ctx.
 * Eg.
 * <pre>
 *  const store = createAsyncStore();
 *  countDownLatch(store, 2, (ctx) => {
 *     // do some counting down
 *     setTimeout(()=> {
 *       ctx.countDown();
 *     }, 1000);
 *     setTimeout(()=> {
 *       ctx.countDown();
 *     }, 1000);
 *  });
 *
 *  Then, either
 *  store.value$.subscribe(()=> {
 *    // count has reached zero
 *  });
 *
 *  or ( in template )
 *  <div *ngIf="store.value$ | async; let state">
 *    <div *ngIf="state.loading"> loading (count has not reached zero yet) </div>
 *    <div *ngIf="!state.loading">count has reached zero</div>
 *  </div>
 * </pre>
 */
export const countDownLatch = (store: ReturnType<typeof createAsyncStore>, count: number, fn: (ctx: CountDownLatchContext)=>void, opts: {checkTimeout: number, maxCheck: number} = { checkTimeout: 200, maxCheck: 200}) => {
  let currentMaxCheck = 0;
  const context: CountDownLatchContext = {
    countDown: () => {
      count--;
    }
  }
  const checkCount = () => {
    setTimeout(()=> {
      currentMaxCheck++;
      if (count <= 0) {
        store.update({});
      } else if (currentMaxCheck >= opts.maxCheck) {
        store.update({});
      } else {
        checkCount();
      }
    }, opts.checkTimeout);
  }
  fn(context);
  checkCount();
}
export interface CountDownLatchContext {
  countDown: ()=>void;
}
